/// section one items start///
const PIECES_SHORT = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_oil_motor.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_116)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M25.0236 17.9146C25.0236 18.199 25.0236 18.4833 24.7393 18.7677C24.4549 19.0521 24.1706 19.0521 23.8862 19.0521H21.6113C21.0426 19.0521 20.4739 18.4833 20.4739 17.9146V16.4928C20.4739 16.2085 20.4739 15.9241 20.1895 15.6397C19.9052 15.6397 19.6208 15.3554 19.3364 15.3554H15.071C14.5023 15.3554 13.9336 14.7867 13.9336 14.2179V12.7961C13.9336 12.5118 13.9336 12.2274 14.218 11.9431C14.5023 11.6587 14.7867 11.6587 15.071 11.6587H30.7108C30.9952 11.6587 31.2796 11.6587 31.2796 11.9431C31.5639 12.2274 31.8483 12.5118 31.8483 12.7961V14.2179C31.8483 14.5023 31.5639 14.7867 31.2796 15.071C31.2796 15.3554 30.9952 15.3554 30.7108 15.3554H26.1611C25.5924 15.3554 25.0236 15.9241 25.0236 16.4928V17.9146Z"
            stroke="#10242B"
            stroke-width="1.4218"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.7448 33.8386C51.7542 36.1135 50.0481 40.6633 49.7637 42.3695C49.195 43.7913 50.0481 45.7818 50.6168 46.3505C51.4699 47.4879 53.7448 48.0567 54.3135 48.0567C56.0197 48.0567 57.7258 46.9192 58.2945 46.3505C59.1476 45.2131 59.432 42.9382 59.1476 42.3695C58.5789 38.9571 56.0197 34.9761 54.8822 33.8386C54.5979 33.2699 54.3135 33.2699 53.7448 33.8386Z"
            stroke="#10242B"
            stroke-width="1.4218"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.5502 20.4736C1.99096 20.4736 0.853516 23.0329 0.853516 24.1703C0.853516 28.7201 0.853516 34.976 0.853516 36.6822C0.853516 39.2414 3.41276 40.3788 4.5502 40.3788C6.54072 40.3788 9.38432 40.3788 10.5218 40.3788V44.6443C10.5218 47.2035 13.081 48.3409 14.2184 48.3409C17.062 48.3409 25.0241 48.3409 30.427 48.3409C31.5644 48.3409 34.6924 47.4879 36.1142 45.7817C39.2421 43.5068 48.0573 34.976 54.0289 27.5826C54.3132 27.0139 54.5976 26.4452 54.5976 26.1608V23.0329C54.5976 22.1798 54.0289 21.6111 53.4601 21.3267C52.8914 21.0424 52.0383 21.0424 51.754 21.3267L37.8203 28.1514C37.2516 28.7201 36.3985 28.4357 36.1142 28.1514C35.5455 27.867 35.2611 27.0139 35.2611 26.7296C35.2611 26.1608 35.2611 25.0234 35.2611 24.1703C35.2611 23.0329 33.8393 20.4736 31.2801 20.4736C27.5834 20.4736 15.0715 20.4736 5.68764 20.4736H4.5502Z"
            stroke="#10242B"
            stroke-width="1.4218"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.5223 35.5448C10.5223 32.7012 10.5223 27.2984 10.5223 25.3079C10.5223 24.4548 9.66926 24.1704 9.3849 24.1704C8.24746 24.1704 6.25694 24.1704 5.68822 24.1704C4.83514 24.1704 4.55078 25.0235 4.55078 25.3079C4.55078 29.2889 4.55078 34.123 4.55078 35.5448C4.55078 36.3979 5.40386 36.6823 5.68822 36.6823C6.82566 36.6823 8.81618 36.6823 9.3849 36.6823C9.95362 36.6823 10.5223 36.1135 10.5223 35.5448Z"
            stroke="#10242B"
            stroke-width="1.4218"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M21.2236 41.2326C20.4696 41.2326 19.8081 41.0532 19.239 40.6943C18.6735 40.3354 18.2313 39.8334 17.9123 39.1882C17.5969 38.5429 17.4392 37.789 17.4392 36.9262C17.4392 36.0563 17.5969 35.2969 17.9123 34.648C18.2313 33.9992 18.6735 33.4953 19.239 33.1365C19.8081 32.7776 20.4696 32.5982 21.2236 32.5982C21.9775 32.5982 22.6373 32.7776 23.2028 33.1365C23.7719 33.4953 24.2141 33.9992 24.5295 34.648C24.8484 35.2969 25.0079 36.0563 25.0079 36.9262C25.0079 37.789 24.8484 38.5429 24.5295 39.1882C24.2141 39.8334 23.7719 40.3354 23.2028 40.6943C22.6373 41.0532 21.9775 41.2326 21.2236 41.2326ZM21.2236 40.0799C21.7963 40.0799 22.2675 39.9331 22.6373 39.6395C23.007 39.3458 23.2807 38.9598 23.4583 38.4813C23.6359 38.0028 23.7247 37.4845 23.7247 36.9262C23.7247 36.368 23.6359 35.8479 23.4583 35.3657C23.2807 34.8836 23.007 34.494 22.6373 34.1967C22.2675 33.8995 21.7963 33.7509 21.2236 33.7509C20.6508 33.7509 20.1796 33.8995 19.8099 34.1967C19.4401 34.494 19.1665 34.8836 18.9888 35.3657C18.8112 35.8479 18.7224 36.368 18.7224 36.9262C18.7224 37.4845 18.8112 38.0028 18.9888 38.4813C19.1665 38.9598 19.4401 39.3458 19.8099 39.6395C20.1796 39.9331 20.6508 40.0799 21.2236 40.0799ZM26.9667 41.0586V32.7069H28.2499V41.0586H26.9667ZM27.6192 31.315C27.3691 31.315 27.1534 31.2298 26.9722 31.0594C26.7945 30.889 26.7057 30.6842 26.7057 30.445C26.7057 30.2058 26.7945 30.0009 26.9722 29.8306C27.1534 29.6602 27.3691 29.575 27.6192 29.575C27.8693 29.575 28.0832 29.6602 28.2608 29.8306C28.442 30.0009 28.5327 30.2058 28.5327 30.445C28.5327 30.6842 28.442 30.889 28.2608 31.0594C28.0832 31.2298 27.8693 31.315 27.6192 31.315ZM31.8834 29.923V41.0586H30.6002V29.923H31.8834Z"
            fill="#373435"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_116">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: -25,
    right: 180,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "روغن موتور",
    pieceNameEN: "oil-motor",
    desc: "تست روغن",
    className: "moveItem1",
    desc: "کار اصلی روغن در موتور خودرو، روان‌سازی و به حداقل رساندن اصطکاک بین اجزای موتور است. ",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_oil_filter.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_93)">
          <path
            d="M14.6016 45.3983V41.6815V41.416C15.1325 41.416 15.6635 41.416 16.1945 41.6815C16.7255 41.947 17.7874 42.478 17.7874 42.478C18.8494 43.2744 19.3803 44.3364 19.3803 44.8673V49.1151"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M26.0191 50.9735V46.7257C26.2846 45.6637 24.4262 44.6018 23.0988 44.3363C22.5678 44.3363 21.5059 44.0708 21.5059 44.0708"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M45.3979 45.3983V41.6815V41.416C44.8669 41.416 44.336 41.416 43.805 41.6815C43.274 41.947 42.2121 42.478 42.2121 42.478C41.1501 43.2744 40.6191 44.3364 40.6191 44.8673V49.1151"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M26.0176 46.7257C26.0176 45.6637 28.6724 45.1327 29.9999 45.1327C32.6547 45.1327 33.9822 46.1947 33.9822 46.7257C33.7167 45.6637 35.8406 44.6018 36.9025 44.3363C37.4335 44.3363 38.4955 44.0708 38.4955 44.0708"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.3105 13.274C35.3105 14.0705 36.638 14.3359 36.638 14.3359C37.6999 14.3359 37.9654 13.274 37.9654 13.274C37.9654 12.743 37.169 12.4775 36.638 12.4775C35.8415 12.4775 35.3105 13.274 35.3105 13.274Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M35.5762 20.9732C35.5762 21.5042 36.3726 22.0352 36.9036 22.0352C37.7001 22.0352 38.231 20.9732 38.231 20.9732C38.231 20.4422 37.4346 20.1768 36.9036 20.1768C36.1071 20.1768 35.5762 20.9732 35.5762 20.9732Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.4961 17.2568C38.4961 17.7877 39.8235 18.0532 39.8235 18.0532C40.8855 18.0532 41.151 17.2568 41.151 17.2568C41.151 16.7258 40.3545 16.1948 39.8235 16.1948C39.0271 16.1948 38.4961 17.2568 38.4961 17.2568Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.3287 11.6812C31.3287 12.2122 30.5322 12.7432 30.0013 12.7432C29.2048 12.7432 28.6738 11.6812 28.6738 11.6812C28.6738 11.1503 29.4703 10.8848 30.0013 10.8848C30.7977 10.8848 31.3287 11.6812 31.3287 11.6812Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.69 13.274C24.69 14.0705 23.3626 14.3359 23.3626 14.3359C22.3006 14.3359 22.0352 13.274 22.0352 13.274C22.0352 12.743 22.8316 12.4775 23.3626 12.4775C24.1591 12.4775 24.69 13.274 24.69 13.274Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M24.4264 20.9732C24.4264 21.5042 23.6299 22.0352 23.0989 22.0352C22.3025 22.0352 21.7715 20.9732 21.7715 20.9732C21.7715 20.4422 23.0989 20.1768 23.0989 20.1768C24.1609 20.1768 24.4264 20.9732 24.4264 20.9732Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.5045 17.2568C21.5045 17.7877 20.177 18.0532 20.177 18.0532C19.1151 18.0532 18.8496 17.2568 18.8496 17.2568C18.8496 16.7258 19.6461 16.1948 20.177 16.1948C20.9735 16.1948 21.5045 17.2568 21.5045 17.2568Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.3287 22.5665C31.3287 23.0975 30.5322 23.3629 30.0013 23.3629C29.2048 23.3629 28.6738 22.5665 28.6738 22.5665C28.6738 22.0355 29.4703 21.77 30.0013 21.77C30.7977 21.77 31.3287 22.5665 31.3287 22.5665Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34.5148 17.2564C34.5148 18.8493 31.5945 19.6458 30.0016 19.6458C26.8157 19.6458 25.4883 18.0529 25.4883 17.2564C25.4883 15.6635 28.4086 14.6016 30.0016 14.6016C32.9219 14.6016 34.5148 16.46 34.5148 17.2564Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.398 15.9291C45.398 22.5663 35.044 25.7521 29.9998 25.7521C19.9113 25.7521 14.6016 19.1149 14.6016 15.9291C14.6016 10.8848 24.9555 8.22998 29.9998 8.22998C40.3538 8.22998 45.398 13.5397 45.398 15.9291Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.7883 17.2565C47.7883 24.6902 35.8413 28.407 30.0006 28.407C18.3192 28.407 12.4785 20.9733 12.4785 17.2565C12.4785 11.1503 24.1599 8.22998 30.0006 8.22998C41.6821 8.22998 47.7883 14.3362 47.7883 17.2565Z"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M12.4785 17.2563L12.744 41.4156C12.744 44.867 18.5847 51.7696 30.0006 51.7696C35.8413 51.7696 47.2573 48.3183 47.2573 41.4156L47.7883 17.2563"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M47.5229 32.124C47.5229 39.5577 35.8415 43.2745 30.0008 43.2745C18.5848 43.2745 12.7441 35.8408 12.7441 32.124"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M33.9824 46.7256V50.9734"
            stroke="#10242B"
            stroke-width="1.59292"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_93">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 75,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر روغن",
    pieceNameEN: "oil-filter",
    className: "moveItem2",
    desc: "فیلتر روغن وظیفه حذف ناخالصی و جذب ذرات مضر از درون روغن موتور را بر عهده دارد.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_filter_motor.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_75)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.6503 44.1557C50.6503 44.6752 50.3905 45.1947 50.1308 45.7142C50.1308 45.7142 49.3516 46.2336 48.8321 46.2336H11.1697C10.1308 46.2336 9.35156 45.4544 9.35156 44.1557V15.5843C9.35156 14.5453 10.1308 13.7661 11.1697 13.7661H48.8321C49.3516 13.7661 50.1308 14.2856 50.1308 14.2856C50.1308 14.2856 50.6503 15.0648 50.6503 15.5843V44.1557Z"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M9.35156 29.8701H50.6503"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M47.0137 13.7661C47.0137 24.6752 47.0137 40.7791 47.0137 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M43.1172 13.7661C43.1172 24.6752 43.1172 40.7791 43.1172 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M39.4805 13.7661C39.4805 24.6752 39.4805 40.7791 39.4805 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M35.584 13.7661C35.584 24.6752 35.584 40.7791 35.584 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M31.9492 13.7661C31.9492 24.6752 31.9492 40.7791 31.9492 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M28.0527 13.7661C28.0527 24.6752 28.0527 40.7791 28.0527 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M24.416 13.7661C24.416 24.6752 24.416 40.7791 24.416 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M20.5195 13.7661C20.5195 24.6752 20.5195 40.7791 20.5195 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M16.8828 13.7661C16.8828 24.6752 16.8828 40.7791 16.8828 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M12.9883 13.7661C12.9883 24.6752 12.9883 40.7791 12.9883 46.2336"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.45508 46.2338C5.45508 47.2727 5.71482 48.3117 6.49404 49.0909C7.27326 49.8701 8.31222 50.1299 9.35118 50.1299H50.6499C52.7278 50.1299 54.546 48.3117 54.546 46.2338V13.7662C54.546 12.7273 54.2862 11.6883 53.507 10.9091C52.7278 10.1299 51.6888 9.87012 50.6499 9.87012H9.35118C8.31222 9.87012 7.27326 10.1299 6.49404 10.9091C5.71482 11.6883 5.45508 12.7273 5.45508 13.7662V46.2338Z"
            stroke="#10242B"
            stroke-width="1.55844"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_75">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 175,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر موتور",
    pieceNameEN: "filter-motor",
    className: "moveItem3",
    desc: "فیلتر موتور خودرو جلوی ورود گرد و غبار و سنگریزه‌ها را به موتور می‌گیرد",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_filter_room.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_55)">
          <path
            d="M7.63281 35.2632H52.3697"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M7.63281 23.9478H52.3697"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M3.42188 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M11.8438 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M15.791 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M20 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M23.9473 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M27.8965 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M32.1055 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M36.0527 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M40.2637 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M44.2109 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M48.4219 16.5791V43.4212"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.89556 47.895C22.6324 47.895 45.0008 47.895 52.3692 47.895C55.264 47.895 56.5798 45.0002 56.5798 43.4213C56.5798 29.2108 56.5798 18.4213 56.5798 16.5792C56.5798 13.6844 53.685 12.3687 52.3692 12.3687C37.3692 12.3687 15.264 12.3687 7.89556 12.3687C5.00082 12.3687 3.42188 15.2634 3.42188 16.5792C3.42188 20.2634 3.42188 36.316 3.42188 43.4213C3.42188 46.316 6.31661 47.895 7.89556 47.895Z"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.2644 43.4212C36.8433 43.4212 16.5802 43.4212 9.73808 43.4212C8.42229 43.4212 7.63281 43.1581 7.63281 43.1581C7.63281 42.1054 7.63281 26.3159 7.63281 18.6844C7.63281 17.3686 9.21176 16.5791 9.73808 16.5791C23.4223 16.5791 43.4223 16.5791 50.2644 16.5791C51.5802 16.5791 52.3697 17.8949 52.3697 18.6844C52.3697 20.7896 52.3697 35.0002 52.3697 41.3159C52.3697 42.8949 51.0539 43.4212 50.2644 43.4212Z"
            stroke="#10242B"
            stroke-width="1.57895"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_55">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 275,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: true,
    pieceName: "فیلتر اتاق",
    pieceNameEN: "filter-room",
    className: "moveItem4",
    desc: " فیلتر کابین نیز هوای تمیز و تصفیه‌شده را در اختیار سرنشینان خودرو قرار می‌دهد",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_filter_petrol.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_46)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M19.9058 27.4764C23.2703 24.1119 28.317 18.7848 30.2796 17.1026C30.8404 16.5418 31.6815 16.8222 31.9619 17.1026C32.2422 17.3829 32.803 17.9437 32.803 17.9437C33.6441 18.5044 33.0833 19.6259 32.803 19.9063C29.4385 23.2708 24.3918 28.3175 22.7095 29.9998C22.1488 30.5605 21.0273 30.2801 20.7469 29.9998C20.4665 29.7194 20.1862 29.439 19.9058 29.1586C19.345 28.5979 19.6254 27.7568 19.9058 27.4764Z"
            stroke="#10242B"
            stroke-width="1.40187"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.8965 35.0466C12.8965 33.9251 13.7376 33.084 14.8591 33.084C15.9806 33.084 16.8217 33.9251 16.8217 35.0466C16.8217 36.1681 15.9806 37.0092 14.8591 37.0092C13.7376 37.0092 12.8965 36.1681 12.8965 35.0466Z"
            stroke="#10242B"
            stroke-width="1.40187"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.0172 19.0652L51.0266 12.0559C51.5873 11.4951 51.5873 10.654 51.0266 10.0933L49.9051 8.97178L49.0639 8.69141C48.5032 8.69141 47.9424 8.97178 47.9424 8.97178L40.9331 15.9811L34.2041 9.25215L33.363 8.97178C32.8023 8.97178 32.2415 9.25215 32.2415 9.25215L31.9611 9.8129L31.4004 10.654C31.4004 11.2148 31.9611 11.7755 31.9611 11.7755L48.5032 28.3176L49.3443 28.5979L50.1854 28.3176L50.7462 27.7568C51.3069 27.1961 51.3069 26.355 50.7462 25.7942L44.0172 19.0652Z"
            stroke="#10242B"
            stroke-width="1.40187"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M47.1022 29.7193C42.3358 34.2053 31.6816 44.8595 27.7564 48.7847C25.7938 51.0277 22.7097 49.9062 21.5882 48.7847L17.9433 45.1399L12.0555 51.0277C11.7751 51.3081 11.4947 51.3081 11.2143 51.3081C10.6536 51.3081 10.3732 51.3081 10.0928 51.0277L8.97134 49.9062C8.41059 49.3455 8.41059 48.5044 8.97134 47.9436L14.8592 42.0558L11.2143 38.4109C9.25172 36.4483 10.0928 33.3642 11.2143 32.2427C19.3452 24.1118 28.0368 15.4202 30.5601 13.1772L47.1022 29.7193Z"
            stroke="#10242B"
            stroke-width="1.40187"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_46">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 400,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر بنزین",
    pieceNameEN: "filter-petrol",
    className: "moveItem5",
    desc: "فیلتر بنزین در سر راه مسیر ورودی بنزین به موتور قرار می گیرد و باعث پاکسازی بنزین از وجود رسوبات و آلاینده ها می شود. ",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_glass_cleaner.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M43.9639 17.6958C47.2818 18.5253 50.5998 19.6313 53.9178 21.2903C55.0238 21.8433 55.8533 22.6728 56.1298 24.0552C56.6828 25.1612 56.4063 26.5437 55.8533 27.6497L49.7703 38.1566C48.6643 40.0921 46.1759 40.9216 43.9639 40.0921C42.5814 39.5391 41.1989 38.9861 39.8164 38.7096"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M13.8252 18.2485C11.0602 19.078 8.57176 20.184 6.08328 21.29C4.97729 21.843 4.14779 22.6725 3.5948 24.055C3.3183 25.161 3.5948 26.5435 4.14779 27.6495L10.2307 38.1564C11.3367 40.3683 13.8252 40.9213 16.0372 40.0919C22.1201 37.6034 28.7561 36.4974 35.392 37.6034"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.2257 19.3545L27.9262 11.0596L32.3501 19.3545C32.6266 19.9075 32.9031 20.4605 32.6266 21.0135C32.3501 23.2255 30.1382 24.8845 27.9262 24.8845C25.4377 24.8845 23.5022 23.2255 22.9492 21.0135C22.9492 20.4605 22.9492 19.9075 23.2257 19.3545Z"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.9952 19.6312L19.6312 7.46533L26.5436 19.6312C26.8201 20.1842 26.8201 20.4607 26.8201 21.0137C26.2671 24.6082 23.2257 27.3732 19.6312 27.3732C16.0367 27.3732 12.9952 24.6082 12.7188 21.0137C12.7188 20.4607 12.7187 20.1842 12.9952 19.6312Z"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M30.416 16.0366C33.181 16.0366 35.6695 16.3131 38.4344 16.5896"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.1624 16.3135H24.6094H25.1624Z"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M34.0096 47.0047L47.558 27.0969C48.111 26.5439 47.8345 25.4379 47.2815 24.8849C46.452 24.3319 45.6225 24.6084 45.0695 25.1614L30.1387 44.2398"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.9902 48.3872C25.9902 46.1752 27.9257 44.2397 30.1377 44.2397C32.3497 44.2397 34.2852 46.1752 34.2852 48.3872C34.2852 50.5992 32.3497 52.5347 30.1377 52.5347C27.9257 52.5347 25.9902 50.5992 25.9902 48.3872Z"
          stroke="#10242B"
          stroke-width="1.38249"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
      </svg>
    ),
    top: 500,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "شیشه شور",
    pieceNameEN: "glassCleaner",
    className: "moveItem6",
    desc: " مایع شیشه شور ماشین در مخزن پلاستیکی مخصوص قرار داشته علاوه بر اینکه رسوب نمی‌کند، وظیفه پاک کردن مخزن، شلنگ‌های رابط و پمپ شیشه شور خودرو را از آلودگی و رسوب بر عهده دارد.",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_radiator.svg",
    svg: (
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M51.0263 44.3587H50.7699V44.6151V45.3844C50.7699 46.41 50.2571 47.4357 49.4879 48.2049C48.9751 48.7177 47.9494 49.2305 46.9238 49.2305H13.0776C11.0263 49.2305 9.23147 47.4357 9.23147 45.3844V27.6921V27.4357H6.15455C5.38532 27.4357 5.12891 26.9228 5.12891 26.1536V24.8716C5.12891 24.3587 5.38532 23.8459 6.15455 23.8459H8.97506C9.23147 23.8459 9.23147 23.5895 9.23147 23.5895V22.8203C9.23147 20.769 11.0263 18.9741 13.0776 18.9741H46.9238C47.9494 18.9741 48.9751 19.4869 49.4879 19.9998C50.2571 20.769 50.7699 21.7946 50.7699 22.8203V40.5126L51.0263 40.769H53.8469C54.1033 40.769 54.6161 41.0254 54.6161 41.0254C54.8725 41.2818 55.1289 41.5382 55.1289 42.051V43.0767C55.1289 43.5895 54.8725 43.8459 54.6161 43.8459C54.6161 44.1023 54.1033 44.3587 53.8469 44.3587H51.0263Z"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M13.334 18.974V17.4356C13.334 16.9227 13.8468 16.1535 13.8468 16.1535C14.1032 15.6407 14.616 15.3843 15.1289 15.3843H37.9494L38.975 15.8971L42.8212 18.974"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M18.7188 15.3844V10.769H23.5905V15.3844"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M17.1797 10.769H25.3848"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M46.9238 22.0513V46.1538"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M13.334 22.0513V46.4102"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M16.9238 22.0513C16.9238 30 16.9238 42.3077 16.9238 46.4102"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M20.7695 22.0513C20.7695 30 20.7695 42.3077 20.7695 46.4102"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M24.3594 22.0513C24.3594 30 24.3594 42.3077 24.3594 46.4102"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M28.2051 22.0513C28.2051 30 28.2051 42.3077 28.2051 46.4102"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M32.0527 22.0513C32.0527 30 32.0527 42.3077 32.0527 46.1538"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M35.6426 22.0513C35.6426 30 35.6426 42.3077 35.6426 46.1538"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M39.4883 22.0513C39.4883 30 39.4883 42.3077 39.4883 46.1538"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
        <path
          d="M43.0781 22.0513C43.0781 30 43.0781 42.3077 43.0781 46.1538"
          stroke="#10242B"
          stroke-width="1.53846"
          stroke-miterlimit="2.61313"
          stroke-linejoin="bevel"
        />
      </svg>
    ),
    top: 600,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "رادیاتور",
    pieceNameEN: "radiatorWater",
    className: "moveItem7",
    desc: " رادیاتور مجموعه‌ای از لوله‌ها و پره‌های دفع حرارت است که در کنار هم می‌توانند آب داغ موتور را خنک کنند. آب به‌وسیله واترپمپ خودرو به درون موتور کشیده و بعد از دفع حرارت وارد رادیاتور می‌شود. رادیاتور ماشین نیز در معرض هوای خنک قرار دارد و می‌تواند حرارت اضافی مایع خنک کننده موتور را دفع کند",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_battery.svg",
    svg: (
      <svg
        width="61"
        height="60"
        viewBox="0 0 61 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_242_2)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M50.7703 14.3241V10.2701C50.7703 8.91872 49.419 8.10791 48.6082 8.10791C45.9055 8.10791 41.8514 8.10791 40.5001 8.10791C39.1487 8.10791 38.3379 9.72953 38.3379 10.2701C38.3379 11.6214 38.3379 13.5133 38.3379 14.3241H50.7703Z"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2305 14.3241V10.2701C10.2305 8.91872 11.8521 8.10791 12.3926 8.10791C15.0953 8.10791 19.1494 8.10791 20.5007 8.10791C21.8521 8.10791 22.6629 9.72953 22.6629 10.2701C22.6629 11.6214 22.6629 13.5133 22.6629 14.3241H10.2305Z"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.7444 47.5676C38.3389 47.5676 15.0957 47.5676 7.25787 47.5676C5.90651 47.5676 5.0957 46.2162 5.0957 45.4054C5.0957 37.8378 5.0957 26.4865 5.0957 22.7027C5.0957 21.3513 6.71733 20.5405 7.25787 20.5405C22.6633 20.5405 45.9065 20.5405 53.7444 20.5405C55.0957 20.5405 55.9065 21.8919 55.9065 22.7027C55.9065 30.2703 55.9065 41.6216 55.9065 45.4054C55.9065 46.7567 54.5552 47.5676 53.7444 47.5676Z"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.09507 51.6212C22.1221 51.6212 47.2572 51.6212 55.9059 51.6212C58.6086 51.6212 59.9599 48.9185 59.9599 47.5672C59.9599 38.378 59.9599 25.1347 59.9599 20.5401C59.9599 17.8374 57.2572 16.2158 55.9059 16.2158C38.8789 16.2158 13.7437 16.2158 5.09507 16.2158C2.39237 16.2158 1.04102 19.1888 1.04102 20.5401C1.04102 29.4591 1.04102 42.9726 1.04102 47.5672C1.04102 50.2699 3.74372 51.6212 5.09507 51.6212Z"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M44.5547 40.2698V27.8374"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M38.3379 34.0537H50.7703"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
          <path
            d="M10.2305 34.0537H22.6629"
            stroke="#10242B"
            stroke-width="1.62162"
            stroke-miterlimit="2.61313"
            stroke-linejoin="bevel"
          />
        </g>
        <defs>
          <clipPath id="clip0_242_2">
            <rect width="61" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 500,
    right: 57,
    opacity: 1,
    visibility: "visible",
    isSelect: false,
    pieceName: "باطری",
    pieceNameEN: "battery",
    className: "moveItem8",
    desc: "باطری مهم ترین قطعه در سیستم الکتریکی خودرو است. وظیفه‌ی این سیستم تامین، ذخیره و تقسیم انرژی الکتریکی مورد نیاز بخش‌های مختلف خودرو است. ",
  },
];

const PIECES_MID = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_engine_candle.svg",
    top: -25,
    right: 180,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "شمع",
    pieceNameEN: "engine-candle",
    className: "moveItem1",
    desc: " شمع ابزاری است برای انتقال جرقه‌های متناوب برق داخل سیلندرها که در انتهای سیلندر و روی سرسیلندر در موتور اتومبیل نصب می‌شود و برق موتور که با حرکت متناوب دلکو به سر شمع‌ها می‌رسد، طوری تنظیم شده که به هنگام فشردگی بخار بنزین در انتهای سیلندر جرقه‌ای از انتهای شمع ساطع شده، و باعث انفجار بنزین و حرکت موتور می شود.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_engine_injector.svg",
    top: 75,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "انژکتور",
    pieceNameEN: "engine-injector",
    className: "moveItem2",
    desc: "انژکتور سیستمی است که وظیفه پاشش سوخت درون سیلندر را بر عهده دارد و در نتیجه در خودروهای پاششی مورد استفاده قرار می‌گیرد.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_tire.svg",
    top: 175,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "لاستیک",
    pieceNameEN: "tire",
    className: "moveItem3",
    desc: "لاستیک خودرو (تایر) بخشی از شاسی ماشین است که به صورت حلقه در اطراف چرخ قرار می‌گیرد. هدف از نصب تایر به دور چرخ، محافظت از رینگ خودرو و عملکرد بهتر آن است. این قطعه همواره در تماس با سطح زمین بوده و در مجاورت آسفالت، شن و ماسه، سنگ ریزه، خاک، گل و … است. از این رو باید از مقاومت مناسبی نسبت به این مواد برخوردار باشد.",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_gearbox.svg",
    top: 275,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: true,
    pieceName: "گیربکس",
    pieceNameEN: "gearbox",
    className: "moveItem4",
    desc: "گیربکس یا همان جعبه دنده خودرو، یکی از قطعات مهمی که حرکت خودرو بدون آن غیرممکن به نظر می‌رسد است. گیربکس میزان معینی از گشتاور تولیدی توسط قوای محرکه را از طریق کلاچ به چرخ‌ها منتقل کرده و جزئی از سیستم انتقال قدرت محسوب میشود",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_engine_injection.svg",
    top: 400,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "اینجکشن",
    pieceNameEN: "engine-injection",
    className: "moveItem5",
    desc: "استفاده از موتورشور نیز همچون استفاده از مکمل‌های جرم‌گیر روش بسیار ساده‌ای دارد. پیش از تعویض روغن، مواد موتورشور را داخل موتور ریخته و پس از آن با توجه به توصیه شرکت سازنده محلول، موتور را دقایقی روشن نگه دارید (در حدود 5 الی 10 دقیقه) تا محلول به‌همراه روغن به‌تمامی بخش‌های موتور خودرو برسد. پس از طی شدن زمان موردنظر روغن خودرو را عوض کنید تا محلول موتورشور نیز به‌همراه رسوبات، از پیشرانه خودرو خارج شود.",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_brake_pad.svg",
    top: 500,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "لنت ترمز",
    pieceNameEN: "brake-pad",
    className: "moveItem6",
    desc: "لنت ترمز بخشی از سامانهٔ ترمز دیسکی است که در خودروها و برخی صنایع دیگر کاربرد دارند. لنت‌های ترمز از صفحه‌های فولادی در پشت و مواد اصطکاکی متصل‌شده به سطح صفحهٔ فلزی، که در مقابل دیسک چرخندهٔ ترمز قرار می‌گیرد، تشکیل شده‌اند.",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_hydraulic.svg",
    top: 600,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "هیدرولیک",
    pieceNameEN: "hydraulic",
    className: "moveItem7",
    desc: "سیستم فرمان برقی هیدرولیک یک سیستم حلقه بسته است که از مایعات هیدرولیک (روغن هیدرولیک) تحت فشار برای تغییر زاویه چرخ های جلو بر اساس زاویه فرمان استفاده می کند. این سیستم شامل یک پمپ هیدرولیک است که توسط کمربند، سوپاپ ها، سیلندر، مخزن و یک مکانیزم کنترل شونده توسط راننده (جعبه دنده شامل چرخ دنده ها و فرمان) هدایت می شود.",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_engine_wash.svg",
    top: 500,
    right: 57,
    opacity: 1,
    visibility: "visible",
    isSelect: false,
    pieceName: "موتورشویی",
    pieceNameEN: "engine-wash",
    className: "moveItem8",
    desc: "تمیز بودن موتور خودرو لاعث کاهش مصرف سوخت و افزایش طول عمر قطعات می شود یکی از بهترین روش ها برای موتورشویی استفاده از بخار است که چربی ها و کثیفی هارا به طور کامل از سطح موتور خودرو می زداید .",
  },
];
const PIECES_LONG = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_suspension.svg",
    top: -25,
    right: 180,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "تعلیق",
    pieceNameEN: "suspension",
    className: "moveItem1",
    desc: "سامانه تعلیق یا فنربندی بخشی از خودرو است که باعث می‌شود نوسانات حاصل از حرکت خودرو بر روی سطوح ناهموار به جِرم معلق که شامل اتاق، شاسی، متعلقات و سرنشینان وارد نشود.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_collage.svg",
    top: 75,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "کلاچ",
    pieceNameEN: "collage",
    className: "moveItem2",
    desc: "کلاچ وسیله‌ای است که به کمک آن راننده هر زمان که بخواهد می‌تواند اتصال موتور را از جعبه‌دنده جدا نماید، بدین معنی که موتور روشن باشد بدون اینکه چرخ دنده‌ها در جعبه‌دنده بچرخند و خودرو حرکت نماید.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_catalyst.svg",
    top: 175,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "کاتالیزور",
    pieceNameEN: "catalyst",
    className: "moveItem3",
    desc: "مبدل کاتالیستی وسیله ای است که سر راه خروجی اگزوز خودرو قرار می گیرد و طی یک سری واکنش های شیمیایی با تبدیل گازهای سمی حاصل از احتراق خودرو به گازهای بی ضرر، از آلودگی هوا جلوگیری می کند. البته این مبدل ها انواع مختلفی دارند و واکنش های شیمیایی هر کدام از آن ها بسته به نوع موتور و سوخت مصرفی متفاوت است.",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_engine_straps.svg",
    top: 275,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: true,
    pieceName: "تسمه ها",
    pieceNameEN: "engine-straps",
    className: "moveItem4",
    desc: "تسمه‌های خودرو یکی از لوازم مصرفی به کار رفته در موتور خودرو هستند. این قطعات لاستیکی وظیفه انتقال نیرو به دستگاه‌هایی مانند فرمان، واتر پمپ و … را به عهده دارند. جنس تسمه‌ها از پلاستیک است و در گذر زمان و تحت تاثیر عوامل مختلف از بین می‌روند.",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_lamp.svg",
    top: 400,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "برق",
    pieceNameEN: "lamp",
    className: "moveItem5",
    desc: "مجموعه ای از سیستم های الکتریکی و الکترونیکی که انرژی مورد نیاز خودرو را تامین می کنند، اساس سیم کشی خودرو را تشکیل می دهند. سیستم برق خودرو، بسیار گسترده و حیاتی برای انجام بخش اعظم وظایف هر خودرو می باشد.",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_cooler.svg",
    top: 500,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "کولر",
    pieceNameEN: "cooler",
    className: "moveItem6",
    desc: "یک سیستم خنک کننده خودرو با چرخاندن مبرد و تبدیل آن از حالت گاز به مایع و سپس بازگشت دوباره آن کار می کند. همینطور که مبرد تغییر حالت می دهد، گرما و رطوبت را از وسیله نقلیه جذب کرده و به سیستم اجازه می دهد هوای خنک و خشک ساطع کند",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_wrenching.svg",
    top: 600,
    right: 200,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "آچارکشی",
    pieceNameEN: "wrenching",
    className: "moveItem7",
    desc: "به‌طورکلی آچارکشی در بررسی کلیه بخش‌های یک خودرو که دارای اتصالات گوناگون از جمله پیچ و مهره هستند بکار می‌رود. این واژه به بررسی شل یا سفت بودن پیچ و مهره‌ها و سفت کردن پیچ‌های شل به ویژه در خودروها بکار می‌رود و جلوبندی نیز به عنوان یکی از اجزای مهم خودرو نیازمند بازدید دوره‌ای و آچارکشی قطعات است.",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_detailing.svg",
    top: 500,
    right: 57,
    opacity: 1,
    visibility: "visible",
    isSelect: false,
    pieceName: "دیتیلینگ",
    pieceNameEN: "detailing",
    className: "moveItem8",
    desc: "پولیش کشیدن تمامی اجزای بیرونی و درونی ماشین به وسیله ی مواد و تجهیزاتی که در حالت عادی در مراکز نظافتی ماشین ها مورد استفاده قرار نمی گیرد، معرفی شده است.",
  },
];


const PIECES_TERMS = [
  {
    id: 1,
    src: "../assets/images/pieces/img_short.svg",
    top: 120,
    right: 105,
    dir: "ltr",
    isSelect: true,
    termsName: "کوتاه مدت",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_mid.svg",
    top: 290,
    right: 140,
    dir: "ltr",
    isSelect: false,
    termsName: "میان مدت",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_long.svg",
    top: 460,
    right: 90,
    dir: "ltr",
    isSelect: false,
    termsName: "بلند مدت",
  },
];
/// section one items end///

/// section two items start///
const PIECES_SHORT2 = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_oil_motor.svg",
    top: 3.5,
    right: 3.5,
    isSelect: true,
    pieceName: "روغن موتور",
    pieceNameEN: "oil-motor",
    desc: "کار اصلی روغن در موتور خودرو، روان‌سازی و به حداقل رساندن اصطکاک بین اجزای موتور است. البته روغن موتورها وظایف بسیار مهم دیگری در موتور خودرو برعهده دارند. جلوگیری از زنگ‌زدگی و خوردگی موتور، پاک‌کنندگی موتور و معلق سازی مواد حاصل از سایش قطعات، آب بندی موتور، حفاظت از سطوح فلزی موتور، افزایش کارایی موتور و برخی از ویژگی‌های دیگر، همگی از وظایف روغن موتور است.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_oil_filter.svg",
    top: 10,
    right: 12,
    isSelect: false,
    pieceName: "فیلتر روغن",
    pieceNameEN: "oil-filter",
    desc: "فیلتر روغن وظیفه حذف ناخالصی و جذب ذرات مضر از درون روغن موتور را بر عهده دارد.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_filter_motor.svg",
    top: 14,
    right: 21.5,
    isSelect: false,
    pieceName: "فیلتر موتور",
    pieceNameEN: "filter-motor",
    desc: "فیلتر موتور خودرو جلوی ورود گرد و غبار و سنگریزه‌ها را به موتور می‌گیرد",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_filter_room.svg",
    top: 16,
    right: 32,
    isSelect: false,
    pieceName: "فیلتر اتاق",
    pieceNameEN: "filter-room",
    desc: " فیلتر کابین نیز هوای تمیز و تصفیه‌شده را در اختیار سرنشینان خودرو قرار می‌دهد",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_filter_petrol.svg",
    top: 16,
    right: 43,
    isSelect: false,
    pieceName: "فیلتر بنزین",
    pieceNameEN: "filter-petrol",
    desc: "فیلتر بنزین در سر راه مسیر ورودی بنزین به موتور قرار می گیرد و باعث پاکسازی بنزین از وجود رسوبات و آلاینده ها می شود. عمل فیلتراسیون بنزین توسط کاغذ های مقاوم در برابر بنزین انجام می شود. به صورتی که آلودگی های درون بنزین در این کاغذ گیر افتاده و به داخل موتور خودرو نفوذ نخواهند کرد",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_glass_cleaner.svg",
    top: 14,
    right: 53.5,
    isSelect: false,
    pieceName: "شیشه شور",
    pieceNameEN: "glassCleaner",
    desc: " مایع شیشه شور ماشین در مخزن پلاستیکی مخصوص قرار داشته علاوه بر اینکه رسوب نمی‌کند، وظیفه پاک کردن مخزن، شلنگ‌های رابط و پمپ شیشه شور خودرو را از آلودگی و رسوب بر عهده دارد. علاوه بر این موارد از شیشه شور ماشین در زمستان برای جلوگیری از ترکیدگی و یخ زدن لاستیک برف پاکن استفاده می‌شود.",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_radiator.svg",
    top: 9.5,
    right: 63,
    isSelect: false,
    pieceName: "رادیاتور",
    pieceNameEN: "radiatorWater",
    desc: "این وسیله مجموعه‌ای از لوله‌ها و پره‌های دفع حرارت است که در کنار هم می‌توانند آب داغ موتور را خنک کنند. آب به‌وسیله واترپمپ خودرو به درون موتور کشیده و بعد از دفع حرارت وارد رادیاتور می‌شود. رادیاتور ماشین نیز در معرض هوای خنک قرار دارد و می‌تواند حرارت اضافی مایع خنک کننده موتور را دفع کند",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_battery.svg",
    top: 3.5,
    right: 72,
    isSelect: false,
    pieceName: "باطری",
    pieceNameEN: "battery",
    desc: "مهم‌ترین قطعه در سیستم الکتریکی خودرو است. وظیفه‌ی این سیستم تامین، ذخیره و تقسیم انرژی الکتریکی مورد نیاز بخش‌های مختلف خودرو است. وقتی خودرو خاموش است، چراغ‌های داخلی و خارجی، سیستم تهویه، سان روف، دستگاه پخش، دزدگیر، بالابر شیشه‌ و برف پاک‌کن از باتری تغذیه می‌کنند. وقتی خودرو روشن می‌شود، وظیفه‌ی تامین انرژی الکتریکی بر عهده‌ی قطعه‌ای به نام دینام است. قسمتی از انرژی تولید شده توسط دینام در باتری ذخیره می‌شود. زمانی که دینام نتواند انرژی مورد نیاز خودرو را تأمین کند، باتری از ذخیره خود برای کمک به دینام استفاده می کند ",
  },
];

const PIECES_MID2 = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_engine_candle.svg",
    top: 3.5,
    right: 3.5,
    isSelect: false,
    pieceName: "شمع",
    pieceNameEN: "engine_candle",
    desc: " شمع ابزاری است برای انتقال جرقه‌های متناوب برق داخل سیلندرها که در انتهای سیلندر و روی سرسیلندر در موتور اتومبیل نصب می‌شود و برق موتور که با حرکت متناوب دلکو به سر شمع‌ها می‌رسد، طوری تنظیم شده که به هنگام فشردگی بخار بنزین در انتهای سیلندر جرقه‌ای از انتهای شمع ساطع شده، و باعث انفجار بنزین و حرکت موتور می شود.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_engine_injector.svg",
    top: 10,
    right: 12,
    isSelect: false,
    pieceName: "انژکتور",
    pieceNameEN: "engine-injector",
    desc: "انژکتور سیستمی است که وظیفه پاشش سوخت درون سیلندر را بر عهده دارد و در نتیجه در خودروهای پاششی مورد استفاده قرار می‌گیرد. این قطعه الکتریکی-مکانیکی در ورودی سیلندر قرار می‌گیرد و عمل تزریق سوخت درون محفظه‌ی احتراق را انجام می‌دهد. انژکتور جایگزینی برای کاربراتور است که در خودروهای قدیمی‌تر بخشی از سیستم سوخت‌رسانی خودرو بود. می‌دانیم که احتراق حاصل از انفجار ترکیب متراکم شده سوخت و هوا، تامین کننده کل انرژی مورد نیاز خود رو است.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_tire.svg",
    top: 14,
    right: 21.5,
    isSelect: false,
    pieceName: "لاستیک",
    pieceNameEN: "tire",
    desc: "لاستیک خودرو (تایر) بخشی از شاسی ماشین است که به صورت حلقه در اطراف چرخ قرار می‌گیرد. هدف از نصب تایر به دور چرخ، محافظت از رینگ خودرو و عملکرد بهتر آن است. این قطعه همواره در تماس با سطح زمین بوده و در مجاورت آسفالت، شن و ماسه، سنگ ریزه، خاک، گل و … است. از این رو باید از مقاومت مناسبی نسبت به این مواد برخوردار باشد.",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_gearbox.svg",
    top: 16,
    right: 32,
    isSelect: false,
    pieceName: "گیربکس",
    pieceNameEN: "gearbox",
    desc: "گیربکس یا همان جعبه دنده خودرو، یکی از قطعات مهمی که حرکت خودرو بدون آن غیرممکن به نظر می‌رسد است. گیربکس میزان معینی از گشتاور تولیدی توسط قوای محرکه را از طریق کلاچ به چرخ‌ها منتقل کرده و جزئی از سیستم انتقال قدرت محسوب میشود ",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_engine_injection.svg",
    top: 16,
    right: 43,
    isSelect: false,
    pieceName: "اینجکشن",
    pieceNameEN: "engine-injection",
    desc: "استفاده از موتورشور نیز همچون استفاده از مکمل‌های جرم‌گیر روش بسیار ساده‌ای دارد. پیش از تعویض روغن، مواد موتورشور را داخل موتور ریخته و پس از آن با توجه به توصیه شرکت سازنده محلول، موتور را دقایقی روشن نگه دارید (در حدود 5 الی 10 دقیقه) تا محلول به‌همراه روغن به‌تمامی بخش‌های موتور خودرو برسد. پس از طی شدن زمان موردنظر روغن خودرو را عوض کنید تا محلول موتورشور نیز به‌همراه رسوبات، از پیشرانه خودرو خارج شود.",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_brake_pad.svg",
    top: 14,
    right: 53.5,
    isSelect: false,
    pieceName: "لنت ترمز",
    pieceNameEN: "brake-pad",
    desc: "لنت ترمز بخشی از سامانهٔ ترمز دیسکی است که در خودروها و برخی صنایع دیگر کاربرد دارند. لنت‌های ترمز از صفحه‌های فولادی در پشت و مواد اصطکاکی متصل‌شده به سطح صفحهٔ فلزی، که در مقابل دیسک چرخندهٔ ترمز قرار می‌گیرد، تشکیل شده‌اند.",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_hydraulic.svg",
    top: 9.5,
    right: 63,
    isSelect: false,
    pieceName: "هیدرولیک",
    pieceNameEN: "hydraulic",
    desc: "سیستم فرمان برقی هیدرولیک یک سیستم حلقه بسته است که از مایعات هیدرولیک (روغن هیدرولیک) تحت فشار برای تغییر زاویه چرخ های جلو بر اساس زاویه فرمان استفاده می کند. این سیستم شامل یک پمپ هیدرولیک است که توسط کمربند، سوپاپ ها، سیلندر، مخزن و یک مکانیزم کنترل شونده توسط راننده (جعبه دنده شامل چرخ دنده ها و فرمان) هدایت می شود.",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_engine_wash.svg",
    top: 3.5,
    right: 72,
    isSelect: false,
    pieceName: "موتورشویی",
    pieceNameEN: "engine-wash",
    desc: "تمیز بودن موتور خودرو لاعث کاهش مصرف سوخت و افزایش طول عمر قطعات می شود یکی از بهترین روش ها برای موتورشویی استفاده از بخار است که چربی ها و کثیفی هارا به طور کامل از سطح موتور خودرو می زداید .",
  },
];

const PIECES_LONG2 = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_suspension.svg",
    top: 3.5,
    right: 3.5,
    isSelect: false,
    pieceName: "تعلیق",
    pieceNameEN: "suspension",
    desc: "سامانه تعلیق یا فنربندی  بخشی از خودرو است که باعث می‌شود نوسانات حاصل از حرکت خودرو بر روی سطوح ناهموار به جِرم معلق که شامل اتاق، شاسی، متعلقات و سرنشینان وارد نشود.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_collage.svg",
    top: 10,
    right: 12,
    isSelect: false,
    pieceName: "کلاچ",
    pieceNameEN: "collage",
    desc: "کلاچ وسیله‌ای است که به کمک آن راننده هر زمان که بخواهد می‌تواند اتصال موتور را از جعبه‌دنده جدا نماید، بدین معنی که موتور روشن باشد بدون اینکه چرخ دنده‌ها در جعبه‌دنده بچرخند و خودرو حرکت نماید.",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_catalyst.svg",
    top: 14,
    right: 21.5,
    isSelect: false,
    pieceName: "کاتالیزور",
    pieceNameEN: "catalyst",
    desc: "مبدل کاتالیستی وسیله ای است که سر راه خروجی اگزوز خودرو قرار می گیرد و طی یک سری واکنش های شیمیایی با تبدیل گازهای سمی حاصل از احتراق خودرو به گازهای بی ضرر، از آلودگی هوا جلوگیری می کند. البته این مبدل ها انواع مختلفی دارند و واکنش های شیمیایی هر کدام از آن ها بسته به نوع موتور و سوخت مصرفی متفاوت است.",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_engine_straps.svg",
    top: 16,
    right: 32,
    isSelect: false,
    pieceName: "تسمه ها",
    pieceNameEN: "engine-straps",
    desc: "تسمه‌های خودرو یکی از لوازم مصرفی به کار رفته در موتور خودرو هستند. این قطعات لاستیکی وظیفه انتقال نیرو به دستگاه‌هایی مانند فرمان، واتر پمپ و … را به عهده دارند. جنس تسمه‌ها از پلاستیک است و در گذر زمان و تحت تاثیر عوامل مختلف از بین می‌روند.",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_lamp.svg",
    top: 16,
    right: 43,
    isSelect: false,
    pieceName: "برق",
    pieceNameEN: "lamp",
    desc: " مجموعه ای از سیستم های الکتریکی و الکترونیکی که انرژی مورد نیاز خودرو را تامین می کنند، اساس سیم کشی خودرو را تشکیل می دهند. سیستم برق خودرو، بسیار گسترده و حیاتی برای انجام بخش اعظم وظایف هر خودرو می باشد.",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_cooler.svg",
    top: 14,
    right: 53.5,
    isSelect: false,
    pieceName: "کولر",
    pieceNameEN: "cooler",
    desc: "یک سیستم خنک کننده خودرو با چرخاندن مبرد و تبدیل آن از حالت گاز به مایع و سپس بازگشت دوباره آن کار می کند. همینطور که مبرد تغییر حالت می دهد، گرما و رطوبت را از وسیله نقلیه جذب کرده و به سیستم اجازه می دهد هوای خنک و خشک ساطع کند",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_wrenching.svg",
    top: 9.5,
    right: 63,
    isSelect: false,
    pieceName: "آچارکشی",
    pieceNameEN: "wrenching",
    desc: "به‌طورکلی آچارکشی در بررسی کلیه بخش‌های یک خودرو که دارای اتصالات گوناگون از جمله پیچ و مهره هستند بکار می‌رود. این واژه به بررسی شل یا سفت بودن پیچ و مهره‌ها و سفت کردن پیچ‌های شل به ویژه در خودروها بکار می‌رود و جلوبندی نیز به عنوان یکی از اجزای مهم خودرو نیازمند بازدید دوره‌ای و آچارکشی قطعات است.",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_detailing.svg",
    top: 3.5,
    right: 72,
    isSelect: false,
    pieceName: "دیتیلینگ",
    pieceNameEN: "detailing",
    desc: " پولیش کشیدن تمامی اجزای بیرونی و درونی ماشین به وسیله ی مواد و تجهیزاتی که در حالت عادی در مراکز نظافتی ماشین ها مورد استفاده قرار نمی گیرد، معرفی شده است.",
  },
];

const PIECES_TERMS2 = [
  {
    id: 1,
    src: "../assets/images/pieces/img_short.svg",
    top: 4.8,
    right: 8.4,
    dir: "ltr",
    isSelect: true,
    termsName: "کوتاه مدت",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_mid.svg",
    top: 7.8,
    right: 25.7,
    dir: "ltr",
    isSelect: false,
    termsName: "میان مدت",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_long.svg",
    top: 5,
    right: 42.4,
    dir: "ltr",
    isSelect: false,
    termsName: "بلند مدت",
  },
];
/// section two items end///

const PIECES_SHORT_MIN = [
  {
    id: 9,
    src: "../assets/images/pieces/img_piece_oil_motor.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.8521 30.4028C22.6665 30.4028 23.3451 30.7014 23.9151 31.2714C24.4852 31.8143 24.7567 32.4929 24.7567 33.3073V36.8091C24.7567 37.5963 24.4852 38.2749 23.9151 38.845C23.3451 39.415 22.6665 39.6865 21.8521 39.6865H19.9791C19.1919 39.6865 18.5132 39.415 17.9432 38.845C17.3731 38.2749 17.1017 37.5963 17.1017 36.8091V33.3073C17.1017 32.4929 17.3731 31.8143 17.9432 31.2714C18.5132 30.7014 19.1919 30.4028 19.9791 30.4028H21.8521ZM27.1726 20.7662C27.1726 20.9562 27.1183 21.119 27.064 21.2819C27.0097 21.4176 26.9011 21.5805 26.7926 21.6891C26.6568 21.8248 26.5211 21.9063 26.3582 21.9605L26.3311 21.9877C26.1954 22.042 26.0325 22.0691 25.8696 22.0691H23.9151C23.5351 22.0691 23.2094 21.9334 22.9922 21.6891L22.9651 21.6619C22.7479 21.4448 22.6122 21.119 22.6122 20.7662V19.5718C22.6122 19.4632 22.585 19.3817 22.5579 19.3274C22.5307 19.246 22.4764 19.1646 22.4221 19.1103C22.3679 19.056 22.2864 19.0017 22.2321 18.9746C22.1507 18.9474 22.0693 18.9203 21.9878 18.9203H18.2689C17.916 18.9203 17.5903 18.7845 17.346 18.5674C17.1017 18.3231 16.9659 17.9973 16.9659 17.6444V16.3958C16.9659 16.2057 16.9931 16.0429 17.0745 15.88C17.1288 15.7443 17.2374 15.5814 17.346 15.4728C17.4545 15.3371 17.6174 15.2556 17.7531 15.1742C17.916 15.1199 18.106 15.0928 18.2689 15.0928H31.5158C31.6787 15.0928 31.8416 15.1199 32.0045 15.1742C32.1673 15.2556 32.3031 15.3371 32.4116 15.4728C32.5474 15.5814 32.6288 15.7443 32.7102 15.88V15.9071C32.7645 16.07 32.7917 16.2329 32.7917 16.3958V17.6444C32.7917 17.8073 32.7645 17.9702 32.7102 18.1331C32.6288 18.2959 32.5474 18.4317 32.4116 18.5674C32.3031 18.676 32.1673 18.7574 32.0045 18.8388H31.9773C31.8144 18.8931 31.6787 18.9203 31.5158 18.9203H27.7969C27.6069 18.9203 27.444 19.0017 27.3355 19.1103C27.2269 19.2189 27.1726 19.3817 27.1726 19.5718V20.7662ZM26.4397 21.0105C26.4668 20.929 26.494 20.8476 26.494 20.7662V19.5718C26.494 19.1917 26.6297 18.866 26.874 18.6488C27.1183 18.4045 27.4169 18.2688 27.7969 18.2688H31.5158C31.5701 18.2688 31.6516 18.2416 31.733 18.2145C31.8144 18.1873 31.8959 18.1331 31.9502 18.0788C32.0045 18.0245 32.0588 17.943 32.0859 17.8887C32.113 17.8073 32.1402 17.7259 32.1402 17.6444V16.3958C32.1402 16.3143 32.113 16.2329 32.0859 16.1514C32.0588 16.07 32.0045 15.9886 31.9502 15.9343C31.8959 15.88 31.8144 15.8257 31.733 15.7986C31.6787 15.7714 31.5973 15.7714 31.5158 15.7714H18.2689C18.1875 15.7714 18.106 15.7714 18.0246 15.7986C17.9432 15.8257 17.8889 15.88 17.8074 15.9343C17.7531 15.9886 17.726 16.07 17.6717 16.1514C17.6446 16.2057 17.6446 16.2872 17.6446 16.3958V17.6444C17.6446 17.8073 17.6989 17.9702 17.8074 18.0788C17.9432 18.1873 18.0789 18.2688 18.2689 18.2688H21.9878C22.1507 18.2688 22.3136 18.2959 22.4493 18.3502C22.585 18.4317 22.7479 18.5131 22.8836 18.6217C23.0193 18.7303 23.1008 18.8931 23.1822 19.056C23.2365 19.2189 23.2637 19.3817 23.2637 19.5718V20.7662C23.2637 20.929 23.3451 21.0919 23.4537 21.2005C23.5623 21.3091 23.7251 21.3905 23.9151 21.3905H25.8696C25.951 21.3905 26.0325 21.3905 26.0868 21.3634C26.1411 21.3362 26.2496 21.2819 26.3039 21.2276C26.3582 21.1462 26.4125 21.0919 26.4397 21.0105ZM51.4405 34.3931C50.7076 35.2618 50.029 36.429 49.4589 37.5963C48.6989 39.1707 48.156 40.7451 47.9931 41.5052C47.8845 41.9938 47.9388 42.5367 48.0745 43.0525C48.2645 43.7583 48.5631 44.3826 48.7803 44.6541C49.0789 45.0341 49.5404 45.3327 50.029 45.577C50.7076 45.8756 51.3591 46.0385 51.712 46.0385C52.2006 46.0385 52.7435 45.8756 53.205 45.6584C53.8836 45.3327 54.4265 44.9255 54.6437 44.6541C54.9694 44.274 55.1595 43.7311 55.2952 43.2425C55.4581 42.5096 55.4852 41.831 55.4309 41.5052C55.1866 40.3651 54.698 39.1164 54.1279 37.9492C53.3679 36.3747 52.4721 34.9903 51.9834 34.3931C51.9292 34.3388 51.902 34.3117 51.8749 34.2845C51.7934 34.2303 51.7391 34.2031 51.712 34.2031C51.6577 34.2031 51.6034 34.2303 51.5491 34.2845C51.4948 34.3117 51.4677 34.3388 51.4405 34.3931ZM48.8617 37.2977C49.4318 36.0761 50.1647 34.8817 50.9248 33.9588C50.9791 33.8774 51.0605 33.8231 51.1148 33.7688C51.3048 33.6059 51.4948 33.5245 51.712 33.5245C51.902 33.5245 52.1192 33.6059 52.3092 33.7688C52.3635 33.8231 52.4178 33.8774 52.4721 33.9588C53.015 34.5831 53.9379 36.0218 54.7523 37.6777C55.3223 38.8721 55.8381 40.1751 56.0824 41.3695C56.1638 41.7767 56.1367 42.591 55.9467 43.4054C55.8109 43.9754 55.5395 44.5998 55.1866 45.0612L55.1595 45.0884C54.9151 45.387 54.2637 45.9028 53.5036 46.2556C52.9335 46.5271 52.3092 46.7171 51.712 46.7171C51.3048 46.7171 50.4905 46.5271 49.7575 46.1742C49.1875 45.9028 48.6446 45.5499 48.2374 45.0884C47.9931 44.7627 47.613 44.0297 47.423 43.2154C47.2873 42.6182 47.2059 41.9667 47.3416 41.3695C47.5045 40.5551 48.0745 38.9264 48.8617 37.2977ZM9.41952 23.2092C8.63231 23.2092 7.98082 23.5621 7.51935 24.0236C6.86786 24.6751 6.54211 25.5437 6.54211 26.0866V36.6733C6.54211 37.4877 6.895 38.112 7.35647 38.5735C8.00796 39.225 8.87661 39.5507 9.41952 39.5507H14.4143C14.5771 39.5507 14.74 39.6865 14.74 39.8765V43.3782C14.74 44.1926 15.0658 44.8169 15.5544 45.2784C16.1787 45.9299 17.0474 46.2556 17.6174 46.2556H31.4344C31.9502 46.2556 32.9817 46.0113 33.9861 45.5499C34.7461 45.2241 35.4791 44.7627 35.9677 44.1926L36.022 44.1655C37.4607 42.9711 40.6095 40.0665 43.9484 36.619C46.4186 34.0945 48.9975 31.2714 51.1419 28.6383C51.2234 28.5297 51.3048 28.3669 51.3591 28.2583C51.4134 28.0411 51.4677 27.8782 51.4677 27.7697V24.9737C51.4677 24.7837 51.3863 24.5665 51.2777 24.4036C51.1419 24.1322 50.9519 23.9422 50.8433 23.8879C50.6805 23.7793 50.4905 23.7521 50.2733 23.725C50.0018 23.725 49.7304 23.7793 49.6218 23.8336L37.8407 29.8327C37.5693 29.9684 37.2435 30.0227 36.9449 29.9956C36.5377 29.9956 36.1306 29.8598 35.9405 29.7513C35.6962 29.5884 35.4791 29.3441 35.3162 29.0726C35.1262 28.7197 35.0176 28.3126 35.0176 28.0954V26.0866C35.0176 25.5437 34.6919 24.6751 34.0675 24.0236C33.606 23.5621 32.9545 23.2092 32.1673 23.2092H9.41952ZM7.05788 23.535C7.62793 22.9649 8.41514 22.5577 9.41952 22.5577H32.1673C33.1717 22.5577 33.9589 22.9649 34.529 23.535C35.3162 24.3222 35.6962 25.408 35.6962 26.0866V28.0954C35.6962 28.2311 35.7777 28.5026 35.9134 28.7469C36.022 28.9098 36.1306 29.0998 36.2934 29.1812C36.402 29.2627 36.6735 29.3169 36.9449 29.3441C37.1621 29.3441 37.3792 29.3169 37.5421 29.2355L49.3232 23.2364C49.5132 23.1278 49.8933 23.0464 50.3004 23.0735C50.599 23.0735 50.9248 23.1549 51.1962 23.3178C51.3863 23.4264 51.6848 23.725 51.8749 24.0779C52.0106 24.3493 52.1192 24.6479 52.1192 24.9737V27.7697C52.1192 27.9325 52.0649 28.204 51.9834 28.4754C51.902 28.6926 51.7934 28.8826 51.6577 29.0455C49.5132 31.7057 46.9073 34.5289 44.437 37.0805C41.071 40.528 37.9222 43.4597 36.4563 44.6541C35.8863 45.3056 35.0719 45.7942 34.2847 46.1742C33.1717 46.6628 32.0045 46.9343 31.4344 46.9343H17.6174C16.9116 46.9343 15.853 46.5271 15.0658 45.767C14.4957 45.1698 14.0614 44.3826 14.0614 43.3782V40.2294H9.41952C8.74089 40.2294 7.65507 39.8222 6.895 39.0621C6.29781 38.4649 5.89062 37.6777 5.89062 36.6733V26.0866C5.89062 25.408 6.27066 24.3222 7.05788 23.535ZM14.0614 35.7504V27.0096C14.0614 26.8467 14.0071 26.711 13.8985 26.6296C13.7356 26.4667 13.5456 26.3852 13.437 26.3852H10.3696C10.1796 26.3852 10.0439 26.4667 9.96243 26.5753H9.93528C9.79956 26.7381 9.71812 26.901 9.71812 27.0096V35.7504C9.71812 35.9133 9.79956 36.049 9.90814 36.1576C10.071 36.2933 10.2339 36.3747 10.3696 36.3747H13.437C13.6542 36.3747 13.7899 36.2662 13.8985 36.1304C13.9799 35.9947 14.0614 35.8318 14.0614 35.7504ZM14.74 27.0096V35.7504C14.74 35.9676 14.6314 36.2662 14.4414 36.5376L14.4143 36.5648C14.1971 36.8362 13.8714 37.0534 13.437 37.0534H10.3696C10.0982 37.0534 9.71812 36.9176 9.44667 36.6462L9.41952 36.619C9.2295 36.4019 9.06663 36.1304 9.06663 35.7504V27.0096C9.06663 26.7653 9.20236 26.3852 9.44667 26.1138L9.47381 26.0866C9.69098 25.8695 9.98957 25.7338 10.3696 25.7338H13.437C13.7085 25.7338 14.0885 25.8695 14.36 26.1409C14.5771 26.3581 14.74 26.6567 14.74 27.0096ZM23.7251 33.3073C23.7251 32.7915 23.5351 32.3572 23.1551 32.0043C22.8022 31.6243 22.3679 31.4614 21.8521 31.4614H19.9791C19.4633 31.4614 19.029 31.6243 18.6761 32.0043C18.3232 32.3572 18.1332 32.7915 18.1332 33.3073V36.8091C18.1332 37.2977 18.3232 37.7591 18.6761 38.112C19.029 38.4649 19.4633 38.6549 19.9791 38.6549H21.8521C22.3679 38.6549 22.8022 38.4649 23.1551 38.112C23.5351 37.7591 23.7251 37.2977 23.7251 36.8091V33.3073ZM26.5211 33.3073H27.5798V39.6865H26.5211V33.3073ZM26.5211 30.4028H27.5798V31.4614H26.5211V30.4028ZM30.5115 37.4877C30.5115 37.8134 30.62 38.0849 30.8644 38.3021C31.0815 38.5464 31.353 38.6549 31.6787 38.6549H32.7645V39.6865H31.6787C31.0815 39.6865 30.5658 39.4693 30.1314 39.035C29.6971 38.6007 29.4799 38.0849 29.4799 37.4877V30.4028H30.5115V37.4877Z"
          fill="#02161D"
          stroke="#02161D"
          strokeWidth="1.52014"
          strokeMiterlimit="2.61313"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    top: 20,
    right: 80,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "روغن موتور",
    pieceNameEN: "oil-motor",
    desc: "تست روغن",
    className: "moveItem1",
    desc: "کار اصلی روغن در موتور خودرو، روان‌سازی و به حداقل رساندن اصطکاک بین اجزای موتور است. ",
  },
  {
    id: 10,
    src: "../assets/images/pieces/img_piece_oil_filter.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_217_26)">
          <path
            d="M30.4153 48.62L30.3905 48.6449C29.1967 48.7444 27.7791 48.62 26.2372 48.1724L28.4258 46.0087C28.5501 45.9092 28.8734 45.76 29.3211 45.6854C29.6941 45.6357 30.1418 45.6108 30.5645 45.7103C30.6889 45.7351 30.9625 45.8098 31.236 45.8844C31.435 45.959 31.6339 46.0087 31.7583 46.0833C31.9572 46.1579 32.1065 46.2574 32.2557 46.3569C32.3303 46.4315 32.4049 46.4812 32.4795 46.5558L30.4153 48.62ZM18.7017 38.3737L16.364 40.7115C15.5184 39.4183 14.6977 37.9261 14.1257 36.409L16.4883 34.0464C16.6624 33.8475 16.8862 33.3749 16.9857 32.7532C17.0355 32.3304 17.0603 31.833 16.9609 31.3108C16.9111 31.1615 16.8365 30.8631 16.7619 30.5895C16.6873 30.3657 16.6127 30.1419 16.5381 29.9678C16.4386 29.744 16.3142 29.5201 16.165 29.3212C16.0158 29.1222 15.8169 28.9481 15.6179 28.7989C15.4687 28.6994 15.2697 28.7243 15.1702 28.8487C14.6231 29.4953 13.9516 30.117 13.305 30.7387C13.504 29.8186 13.9019 28.973 14.5734 28.3015L17.881 24.8695C17.309 26.7596 17.5577 28.9979 18.2541 31.1615C19.2986 34.32 21.2633 37.3789 22.9544 39.0452C25.715 41.8306 28.6993 43.2731 31.4101 43.8699C33.7727 44.3922 35.9115 44.243 37.5032 43.7456L33.6981 47.4263C33.2256 47.8988 32.4546 48.2718 31.4598 48.4957C32.007 47.9237 32.579 47.3268 33.151 46.8294C33.2753 46.7299 33.3002 46.531 33.2007 46.3818C33.0515 46.1828 32.8774 46.0087 32.6785 45.8346C32.4795 45.6854 32.2805 45.5611 32.0319 45.4616C31.8578 45.387 31.6339 45.3124 31.435 45.2377C31.1365 45.1631 30.8381 45.0885 30.6889 45.0637C30.1666 44.9393 29.6692 44.9642 29.2465 45.0139L29.2216 45.0388C28.6247 45.1383 28.1522 45.3372 27.9532 45.5113L25.516 47.9485C24.1482 47.476 22.6809 46.7548 21.2136 45.7103L23.6259 43.2979V43.273C23.6508 43.2233 23.7254 43.1984 23.7503 43.1487C23.9244 43.0244 24.2725 43.0244 24.6953 43.099C25.2424 43.1984 25.8393 43.4471 26.2124 43.671C26.3864 43.7456 26.5854 43.8948 26.7595 44.0191C26.9833 44.1932 27.1823 44.3673 27.2818 44.4668C27.4061 44.5911 27.6299 44.5911 27.7543 44.4668C27.8786 44.3176 27.8786 44.1186 27.7543 43.9943C27.6548 43.8948 27.431 43.6958 27.1574 43.4969C26.9584 43.3477 26.7595 43.1984 26.5605 43.0741C26.1377 42.8254 25.4414 42.5518 24.8197 42.4524C24.4964 42.3777 24.1979 42.3529 23.9244 42.4026C23.8995 42.0793 23.7751 41.7063 23.601 41.3332C23.2777 40.6866 22.7803 40.0151 22.3824 39.6172C21.5866 38.8463 20.8156 38.4235 20.2188 38.2245C19.9949 38.1748 19.7711 38.125 19.597 38.125C19.6468 37.8515 19.6219 37.5282 19.5722 37.2049C19.4478 36.5582 19.1743 35.8619 18.9256 35.4391C18.8012 35.265 18.652 35.0412 18.5276 34.8422C18.3038 34.5935 18.1049 34.3448 18.0302 34.2454C17.881 34.121 17.6821 34.121 17.5329 34.2454C17.4085 34.3946 17.4085 34.5935 17.5329 34.7179C17.6323 34.8174 17.8064 35.0163 17.9805 35.2402C18.1049 35.4391 18.2541 35.6132 18.3536 35.7873C18.5525 36.1603 18.8012 36.7572 18.9007 37.3292C18.9753 37.752 18.9753 38.125 18.8261 38.2743C18.8012 38.2991 18.7763 38.324 18.7515 38.3489L18.7266 38.3737H18.7017ZM16.7619 41.2835L19.1743 38.8711L19.2489 38.7965C19.3732 38.7468 19.6468 38.7716 20.0198 38.8711C20.5421 39.0203 21.2136 39.3934 21.9099 40.0897C22.2581 40.4379 22.7057 41.0597 22.9793 41.6317C23.2031 42.0793 23.3275 42.5021 23.228 42.7259C23.1783 42.7757 23.1534 42.8005 23.1285 42.8254L20.7162 45.2626L20.6664 45.3124C19.9701 44.7652 19.2737 44.1435 18.5525 43.4471C17.9805 42.8751 17.3588 42.129 16.7619 41.2835ZM19.3732 22.3577C19.3235 22.4074 19.2737 22.4572 19.224 22.5069L14.1008 27.829C12.36 29.5699 12.2108 32.1315 12.9071 34.7925C13.8024 38.324 16.165 42.0047 18.08 43.9197C24.7699 50.6096 32.1562 49.9381 34.1706 47.9237L48.1722 34.3946C48.1971 34.3697 48.222 34.3448 48.2717 34.2951C49.7888 32.7781 49.739 30.316 48.8935 27.7544C47.7992 24.4219 45.362 20.8406 43.4221 18.8511L43.3724 18.8013L43.3475 18.7765L43.2978 18.7018L43.1734 18.6024L43.1486 18.5775C40.3383 15.7921 37.5032 14.1756 35.0411 13.3549C31.5345 12.2109 28.7491 12.6834 27.7045 13.7528C27.6548 13.8025 27.6051 13.8523 27.5304 13.902L19.3732 22.3577ZM39.1694 42.1539C37.9757 43.2482 35.0411 43.9943 31.5345 43.2233C28.9729 42.6513 26.088 41.2586 23.427 38.5727C21.8104 36.9562 19.8955 34.0215 18.9007 30.9377C17.9556 28.0031 17.8562 24.9441 19.7463 22.9546L19.8457 22.8302H19.8706L26.2124 16.2398C25.6404 18.1547 25.9139 20.393 26.6351 22.5815C27.7045 25.7897 29.719 28.8735 31.435 30.5895C34.295 33.4495 37.354 34.9666 40.0647 35.5883C42.3776 36.1106 44.4915 35.9862 46.0583 35.5137L39.1694 42.1539ZM13.877 35.7127C13.7527 35.3396 13.6283 34.9915 13.5537 34.6184C13.2801 33.6236 13.1558 32.6288 13.2055 31.6838C13.2553 31.6838 13.3299 31.6589 13.3796 31.5843L15.4438 29.5201C15.5184 29.5947 15.593 29.6694 15.6428 29.744C15.7671 29.8932 15.8666 30.0424 15.9412 30.2414C15.9909 30.3906 16.0655 30.5647 16.1153 30.7636C16.1899 31.0372 16.2645 31.3108 16.2894 31.4351C16.3889 31.8828 16.364 32.3055 16.3142 32.6537C16.2396 33.1014 16.1153 33.4495 15.9909 33.5988L13.877 35.7127ZM27.2818 22.3826C26.287 19.3485 26.1875 16.2149 28.1771 14.2253C28.8734 13.529 30.5148 13.1559 32.6785 13.4792C31.2858 13.4792 30.2164 13.8523 29.6941 14.3994C28.0527 16.0408 27.8538 18.4034 28.4009 20.8158C29.1221 24.0488 31.2112 27.3565 32.9272 29.0725C35.439 31.5843 38.0752 32.9024 40.4378 33.4495C43.7206 34.1956 46.4811 33.4247 47.6002 32.3055C48.3215 31.5843 48.6448 30.6393 48.6696 29.5699C48.9929 31.2859 48.794 32.8278 47.7992 33.8226C46.6303 34.9915 43.7206 35.7375 40.214 34.9417C37.6026 34.3448 34.668 32.8775 31.9075 30.0921C30.2661 28.4507 28.3014 25.4664 27.2818 22.3826ZM29.0475 20.6665C28.5501 18.478 28.7242 16.3144 30.1666 14.8719C30.9376 14.101 33.1012 13.7777 35.8866 14.6978C37.926 15.3693 40.2388 16.6874 42.6014 18.9754L42.6761 19.05L42.7009 19.0749L42.8253 19.1992L42.875 19.249L42.8999 19.2738L42.9496 19.3236C44.3672 20.766 46.0583 23.2033 47.1029 25.6405C48.1225 28.0777 48.4955 30.4901 47.1277 31.833C46.1329 32.8278 43.6211 33.4744 40.587 32.7781C38.3487 32.2807 35.812 31.0123 33.3997 28.6C31.7583 26.9586 29.7438 23.7753 29.0475 20.6665ZM35.1654 21.1888C34.668 21.6862 34.6432 22.4323 34.8919 23.2033C35.1654 24.1483 35.8369 25.168 36.384 25.6902C37.155 26.4612 37.9508 26.9088 38.6472 27.1078C39.6668 27.4311 40.5124 27.2321 40.8606 26.9088C41.358 26.4114 41.3828 25.6653 41.1341 24.8944C40.8606 23.9493 40.1891 22.9546 39.642 22.4074C38.871 21.6365 38.0752 21.1888 37.3788 20.9899C36.3592 20.6665 35.4887 20.8655 35.1654 21.1888ZM35.5136 23.0043C35.3644 22.4572 35.3395 21.9598 35.6379 21.6613C35.8369 21.4624 36.4089 21.3878 37.1799 21.6116C37.7767 21.8106 38.4731 22.1836 39.1694 22.8799C39.642 23.3525 40.2388 24.2478 40.5124 25.0933C40.6616 25.6405 40.6865 26.1379 40.388 26.4363C40.1891 26.6353 39.6171 26.7099 38.8461 26.486C38.2493 26.2871 37.5529 25.914 36.8566 25.2177C36.384 24.7452 35.7623 23.8499 35.5136 23.0043ZM33.9219 26.113C33.6484 26.3866 33.6235 26.7596 33.723 27.1078C33.8225 27.4062 33.9966 27.6798 34.1458 27.8539C34.4193 28.1026 34.7178 28.2518 34.9665 28.3015C35.3644 28.3761 35.7374 28.2518 35.8866 28.0777C36.1353 27.8539 36.1851 27.5306 36.1105 27.2321C36.0607 26.884 35.8369 26.5358 35.6628 26.3368C35.3893 26.0881 35.1157 25.9389 34.8421 25.8892C34.4442 25.8146 34.0712 25.9389 33.9219 26.113ZM34.3696 26.9088C34.3447 26.7845 34.3199 26.6601 34.3945 26.5855C34.4442 26.5358 34.5437 26.5358 34.7178 26.5607C34.867 26.5855 35.0162 26.6601 35.1903 26.8093C35.2898 26.9337 35.4141 27.1327 35.4639 27.3565C35.4887 27.456 35.4639 27.5554 35.4141 27.6052C35.3893 27.6549 35.2649 27.6549 35.0908 27.63C34.9665 27.6052 34.7924 27.5306 34.6432 27.3813C34.5437 27.2819 34.4193 27.1078 34.3696 26.9088ZM42.6014 28.6746C42.3279 28.9481 42.3279 29.3212 42.4274 29.6694C42.502 29.9678 42.6761 30.2414 42.8501 30.4154C43.0988 30.6641 43.3973 30.8134 43.6708 30.8631C44.0688 30.9377 44.4169 30.8134 44.591 30.6393C44.8148 30.4154 44.8646 30.0921 44.8148 29.7937C44.7402 29.4455 44.5164 29.0725 44.3423 28.8984C44.0936 28.6497 43.7952 28.5005 43.5216 28.4507C43.1237 28.3761 42.7755 28.5005 42.6014 28.6746ZM43.074 29.4704C43.0242 29.3461 43.0242 29.1968 43.074 29.1471C43.1237 29.0974 43.2481 29.0725 43.3973 29.1222C43.5465 29.1471 43.7206 29.2217 43.8698 29.3709C43.9693 29.4953 44.1185 29.6942 44.1434 29.9181C44.1682 30.0175 44.1682 30.117 44.1185 30.1668C44.0688 30.1916 43.9444 30.2165 43.7952 30.1916C43.646 30.1667 43.4719 30.0921 43.3227 29.9181C43.2232 29.8434 43.1237 29.6694 43.074 29.4704ZM38.7218 29.1222C38.4482 29.3958 38.4482 29.7688 38.5477 30.117C38.6223 30.4154 38.7964 30.689 38.9705 30.8382C39.2192 31.1118 39.5176 31.2361 39.7912 31.2859C40.1891 31.3605 40.5373 31.2361 40.7114 31.0869C40.9352 30.8631 40.9849 30.5398 40.9352 30.2414C40.8606 29.8932 40.6367 29.5201 40.4627 29.3461C40.1891 29.0725 39.9155 28.9481 39.642 28.8984C39.244 28.8238 38.8959 28.9481 38.7218 29.1222ZM39.1694 29.9181C39.1446 29.7937 39.1446 29.6445 39.1943 29.5947C39.244 29.545 39.3684 29.5201 39.5176 29.5699C39.6668 29.5947 39.8409 29.6694 39.9901 29.8186C40.0896 29.9429 40.214 30.1419 40.2637 30.3657C40.2886 30.4652 40.2886 30.5647 40.214 30.6144C40.1891 30.6393 40.0647 30.6641 39.9155 30.6393C39.7663 30.6144 39.5922 30.5398 39.443 30.3657C39.3435 30.2911 39.244 30.117 39.1694 29.9181ZM42.9994 24.6954C42.7755 24.9441 42.7258 25.2426 42.7755 25.541C42.8501 25.8892 43.0491 26.2622 43.2481 26.4363C43.4968 26.7099 43.7952 26.8342 44.0688 26.884C44.4667 26.9586 44.8148 26.8342 44.9889 26.685C45.2128 26.4363 45.2625 26.1379 45.2128 25.8146C45.1381 25.4664 44.9143 25.1182 44.7402 24.9441C44.4667 24.6706 44.1931 24.5462 43.9195 24.4965C43.5216 24.4219 43.1734 24.5462 42.9994 24.6954ZM43.447 25.4166C43.4221 25.3172 43.4221 25.2177 43.4719 25.168C43.5216 25.1431 43.6211 25.1182 43.7952 25.1431C43.9444 25.168 44.1185 25.2426 44.2677 25.4166C44.3672 25.5161 44.4915 25.74 44.5413 25.9389C44.5661 26.0384 44.5661 26.1379 44.4915 26.1876C44.4667 26.2373 44.3423 26.2622 44.1931 26.2373C44.0439 26.1876 43.8698 26.113 43.7206 25.9638C43.5962 25.8643 43.4719 25.6405 43.447 25.4166ZM40.1145 19.9205C39.8658 20.1443 39.8409 20.4676 39.8907 20.766C39.9653 21.1142 40.1642 21.4872 40.3383 21.6613C40.6119 21.91 40.9103 22.0592 41.159 22.109C41.5569 22.1836 41.93 22.0592 42.0792 21.8852C42.3528 21.6116 42.3776 21.2386 42.2781 20.8904C42.1787 20.5919 42.0046 20.3184 41.8554 20.1443C41.5818 19.8956 41.2834 19.7464 41.0347 19.6966C40.6367 19.622 40.2637 19.7464 40.1145 19.9205ZM40.5373 20.6417C40.5373 20.5422 40.5373 20.4427 40.587 20.393C40.6119 20.3681 40.7362 20.3432 40.9103 20.3681C41.0595 20.393 41.2087 20.4676 41.3828 20.6417C41.4574 20.7163 41.5818 20.8904 41.6315 21.0893C41.6813 21.2137 41.6813 21.3629 41.6067 21.4126C41.5818 21.4624 41.4574 21.4872 41.2834 21.4375C41.1341 21.4126 40.9849 21.338 40.8108 21.1888C40.7114 21.0645 40.587 20.8655 40.5373 20.6417ZM32.8525 18.9257C32.8028 19.0003 32.6536 18.9754 32.5292 18.9505L32.5044 18.9257C32.3303 18.8759 32.1562 18.7765 32.0816 18.677C31.9075 18.5278 31.8329 18.3537 31.808 18.2045C31.7832 18.0552 31.808 17.9309 31.8329 17.906C31.8826 17.8314 31.9821 17.8314 32.0816 17.8563C32.3054 17.906 32.5292 18.0304 32.6287 18.1298C32.7779 18.2791 32.8526 18.4532 32.8774 18.6024C32.9272 18.7765 32.9023 18.8759 32.8525 18.9257ZM32.3303 19.5723C32.6785 19.6966 33.0515 19.6718 33.3251 19.3982C33.4992 19.2241 33.6235 18.8759 33.5489 18.478C33.4992 18.2045 33.3748 17.9309 33.1012 17.6573C32.9272 17.4832 32.5541 17.2594 32.2059 17.2097C31.9075 17.1351 31.6091 17.1848 31.3604 17.4335C31.2112 17.5827 31.0868 17.9309 31.1614 18.3288C31.2112 18.6024 31.3355 18.9008 31.6091 19.1495C31.7583 19.3236 32.0567 19.4977 32.3303 19.5723ZM32.4049 22.8053C32.3552 22.8799 32.2059 22.8551 32.0816 22.8302L32.0567 22.8053C31.8826 22.7556 31.7085 22.6561 31.6339 22.5566C31.4598 22.4074 31.3852 22.2333 31.3604 22.0841C31.3355 21.9349 31.3604 21.8106 31.3852 21.7857C31.435 21.7359 31.5345 21.7111 31.6339 21.7359C31.8578 21.7857 32.0816 21.91 32.1811 22.0095C32.3303 22.1836 32.4049 22.3328 32.4546 22.482C32.4795 22.6561 32.4546 22.7556 32.4049 22.8053ZM31.8826 23.4768C32.2308 23.5763 32.6287 23.5514 32.9023 23.2779C33.0515 23.1286 33.1759 22.7556 33.1012 22.3577C33.0515 22.0841 32.9272 21.8106 32.6536 21.537C32.4795 21.3629 32.1313 21.1391 31.7583 21.0893C31.4598 21.0147 31.1614 21.0645 30.9127 21.3132C30.7635 21.4624 30.6392 21.8354 30.7138 22.2085C30.7635 22.482 30.8878 22.7805 31.1614 23.0292C31.3106 23.2033 31.5842 23.4022 31.8826 23.4768ZM36.8317 18.5278C36.782 18.5775 36.6825 18.5775 36.583 18.5775C36.3592 18.5278 36.1602 18.4034 36.0359 18.2791C35.8866 18.1298 35.812 17.9558 35.7872 17.8314C35.7374 17.6573 35.7623 17.533 35.812 17.5081C35.8618 17.4584 35.9613 17.4335 36.0607 17.4584C36.2597 17.5081 36.4835 17.6325 36.583 17.7319C36.7571 17.906 36.8317 18.0552 36.8566 18.2045C36.8814 18.3785 36.8566 18.478 36.8317 18.5278ZM36.4586 19.2241C36.7571 19.2738 37.0804 19.249 37.3042 19.0003C37.4534 18.8511 37.5778 18.478 37.5032 18.0801C37.4534 17.8065 37.3291 17.533 37.0555 17.2594C36.8814 17.0853 36.5333 16.8615 36.1851 16.8118C35.8866 16.7371 35.5633 16.7869 35.3395 17.0356C35.1654 17.1848 35.0411 17.5578 35.1157 17.9558C35.1654 18.2045 35.2898 18.5029 35.5633 18.7765C35.7374 18.9505 36.1105 19.1495 36.4586 19.2241Z"
            fill="#02161D"
            stroke="#02161D"
            strokeWidth="0.994785"
            strokeMiterlimit="2.61313"
          />
        </g>
        <defs>
          <clipPath id="clip0_217_26">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 60,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر روغن",
    pieceNameEN: "oil-filter",
    className: "moveItem2",
    desc: "فیلتر روغن وظیفه حذف ناخالصی و جذب ذرات مضر از درون روغن موتور را بر عهده دارد.",
  },
  {
    id: 11,
    src: "../assets/images/pieces/img_piece_filter_motor.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_217_7)">
          <path
            d="M48.0091 42.5127C48.0091 42.7693 47.9551 43.0123 47.8606 43.2419C47.766 43.485 47.631 43.6876 47.4419 43.8766C47.2664 44.0522 47.0503 44.1872 46.8207 44.2818C46.5911 44.3898 46.3345 44.4303 46.0915 44.4303H15.9085C15.3818 44.4303 14.8956 44.2143 14.558 43.8766C14.2069 43.5255 13.9908 43.0394 13.9908 42.5127V19.4872C13.9908 18.9605 14.2069 18.4743 14.558 18.1232C14.8956 17.7856 15.3818 17.5695 15.9085 17.5695H46.0915C46.3345 17.5695 46.5911 17.61 46.8207 17.7046C47.0503 17.8126 47.2664 17.9477 47.4419 18.1232C47.631 18.3123 47.766 18.5148 47.8606 18.7579C47.9551 18.9875 48.0091 19.2306 48.0091 19.4872V42.5127ZM11.506 44.0657C11.506 44.4438 11.587 44.822 11.722 45.1596C11.8706 45.4972 12.0732 45.8078 12.3433 46.0779C12.6134 46.348 12.924 46.5641 13.2616 46.6991C13.5992 46.8342 13.9773 46.9152 14.3555 46.9152H47.6445C48.4278 46.9152 49.1435 46.5911 49.6567 46.0779C50.1699 45.5647 50.494 44.8625 50.494 44.0657V17.9341C50.494 17.5425 50.413 17.1779 50.2779 16.8403C50.1294 16.5026 49.9268 16.192 49.6567 15.9219C49.3866 15.6519 49.076 15.4358 48.7384 15.3007C48.4008 15.1657 48.0226 15.0847 47.6445 15.0847H14.3555C13.9773 15.0847 13.5992 15.1657 13.2616 15.3007C12.924 15.4358 12.6134 15.6519 12.3433 15.9219C12.0732 16.192 11.8706 16.5026 11.722 16.8403C11.587 17.1779 11.506 17.5425 11.506 17.9341V44.0657ZM11.1008 45.4162C10.9253 44.9975 10.8442 44.5384 10.8442 44.0657V17.9341C10.8442 17.4615 10.9253 17.0023 11.1008 16.5837C11.2764 16.165 11.5465 15.7734 11.8706 15.4493C12.1947 15.1117 12.5863 14.8551 13.005 14.6795C13.4371 14.504 13.8828 14.4094 14.3555 14.4094H47.6445C48.1172 14.4094 48.5628 14.504 48.995 14.6795C49.4136 14.8551 49.8052 15.1117 50.1294 15.4493C50.4535 15.7734 50.7236 16.165 50.8991 16.5837C51.0612 17.0023 51.1557 17.4615 51.1557 17.9341V44.0657C51.1557 45.038 50.7641 45.9159 50.1294 46.5506C49.4946 47.1853 48.6168 47.5904 47.6445 47.5904H14.3555C13.8828 47.5904 13.4371 47.4959 13.005 47.3203C12.5863 47.1448 12.1947 46.8882 11.8706 46.5506C11.533 46.2265 11.2764 45.8348 11.1008 45.4162ZM17.502 18.2312V30.8581H20.2435V18.2312H17.502ZM17.502 31.1417V43.7686H20.2435V31.1417H17.502ZM17.2049 43.7686V31.1417H14.6526V42.5127C14.6526 42.8503 14.8011 43.1744 15.0307 43.3905C15.2468 43.6201 15.5709 43.7686 15.9085 43.7686H17.2049ZM17.2049 30.8581V18.2312H15.9085C15.5709 18.2312 15.2468 18.3798 15.0307 18.5959C14.8011 18.8255 14.6526 19.1361 14.6526 19.4872V30.8581H17.2049ZM20.5271 18.2312V30.8581H23.2685V18.2312H20.5271ZM20.5271 31.1417V43.7686H23.2685V31.1417H20.5271ZM23.5657 18.2312V30.8581H26.3071V18.2312H23.5657ZM23.5657 31.1417V43.7686H26.3071V31.1417H23.5657ZM26.5907 18.2312V30.8581H29.3321V18.2312H26.5907ZM26.5907 31.1417V43.7686H29.3321V31.1417H26.5907ZM29.6293 18.2312V30.8581H32.3707V18.2312H29.6293ZM29.6293 31.1417V43.7686H32.3707V31.1417H29.6293ZM32.6543 18.2312V30.8581H35.4093V18.2312H32.6543ZM32.6543 31.1417V43.7686H35.4093V31.1417H32.6543ZM35.6929 18.2312V30.8581H38.4343V18.2312H35.6929ZM35.6929 31.1417V43.7686H38.4343V31.1417H35.6929ZM38.7179 18.2312V30.8581H41.4729V18.2312H38.7179ZM38.7179 31.1417V43.7686H41.4729V31.1417H38.7179ZM41.7565 18.2312V30.8581H44.4979V18.2312H41.7565ZM41.7565 31.1417V43.7686H44.4979V31.1417H41.7565ZM44.7815 18.2312V30.8581H47.3339V19.4872C47.3339 19.3251 47.3069 19.1631 47.2394 19.001C47.1853 18.866 47.0908 18.7174 46.9693 18.5959C46.8477 18.4878 46.7127 18.3933 46.5641 18.3258C46.4156 18.2718 46.2535 18.2312 46.0915 18.2312H44.7815ZM44.7815 31.1417V43.7686H46.0915C46.2535 43.7686 46.4156 43.7281 46.5641 43.6741C46.7127 43.6065 46.8477 43.512 46.9693 43.3905C47.0908 43.2824 47.1853 43.1339 47.2394 42.9853C47.3069 42.8368 47.3339 42.6747 47.3339 42.5127V31.1417H44.7815Z"
            fill="#02161D"
            stroke="black"
            strokeWidth="1.01285"
            strokeMiterlimit="2.61313"
          />
        </g>
        <defs>
          <clipPath id="clip0_217_7">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 100,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر موتور",
    pieceNameEN: "filter-motor",
    className: "moveItem3",
    desc: "فیلتر موتور قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
  {
    id: 12,
    src: "../assets/images/pieces/img_piece_filter_room.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_217_17)">
          <path
            d="M13.1636 34.9647H16.1849V26.2151H13.1636V34.9647ZM13.1636 25.9231H16.1849V20.1499C16.1849 20.1274 16.1962 20.105 16.2074 20.0825H15.5223C14.8708 20.0825 14.3429 20.3633 13.961 20.7452L13.9498 20.7676C13.4219 21.2955 13.1636 22.0031 13.1636 22.4524V25.9231ZM16.4657 20.0825C16.477 20.105 16.477 20.1274 16.477 20.1499V25.9231H19.4422V20.1499C19.4422 20.1274 19.4534 20.105 19.4647 20.0825H16.4657ZM19.723 20.0825C19.7342 20.105 19.7342 20.1274 19.7342 20.1499V25.9231H22.7107V20.1499C22.7107 20.1274 22.7107 20.105 22.7219 20.0825H19.723ZM22.9802 20.0825C22.9915 20.105 22.9915 20.1274 22.9915 20.1499V25.9231H25.9679V20.1499C25.9679 20.1274 25.9679 20.105 25.9791 20.0825H22.9802ZM26.2375 20.0825C26.2487 20.105 26.2599 20.1274 26.2599 20.1499V25.9231H29.2252V20.1499C29.2252 20.1274 29.2252 20.105 29.2364 20.0825H26.2375ZM29.4947 20.0825C29.506 20.105 29.5172 20.1274 29.5172 20.1499V25.9231H32.4824V20.1499C32.4824 20.1274 32.4936 20.105 32.5049 20.0825H29.4947ZM32.7632 20.0825C32.7632 20.105 32.7744 20.1274 32.7744 20.1499V25.9231H35.7397V20.1499C35.7397 20.1274 35.7509 20.105 35.7621 20.0825H32.7632ZM36.0205 20.0825C36.0317 20.105 36.0317 20.1274 36.0317 20.1499V25.9231H38.9969V20.1499C38.9969 20.1274 39.0081 20.105 39.0194 20.0825H36.0205ZM39.2777 20.0825C39.2889 20.105 39.2889 20.1274 39.2889 20.1499V25.9231H42.2654V20.1499C42.2654 20.1274 42.2654 20.105 42.2766 20.0825H39.2777ZM42.5349 20.0825C42.5462 20.105 42.5574 20.1274 42.5574 20.1499V25.9231H45.5226V20.1499C45.5226 20.1274 45.5226 20.105 45.5339 20.0825H42.5349ZM45.7922 20.0825C45.8034 20.105 45.8147 20.1274 45.8147 20.1499V25.9231H48.836V22.4524C48.836 21.7897 48.5552 21.2731 48.1733 20.8912C47.6342 20.3521 46.9266 20.0825 46.4773 20.0825H45.7922ZM48.836 26.2151H45.8147V34.9647H48.836V26.2151ZM48.836 35.2568H45.8147V41.8499C45.8147 41.8723 45.8034 41.8948 45.7922 41.906H46.4773C47.2523 41.906 47.8476 41.5129 48.2407 41.03C48.6339 40.5245 48.836 39.9292 48.836 39.5473V35.2568ZM45.5339 41.906C45.5226 41.8948 45.5226 41.8723 45.5226 41.8499V35.2568H42.5574V41.8499C42.5574 41.8723 42.5462 41.8948 42.5349 41.906H45.5339ZM42.2766 41.906C42.2654 41.8948 42.2654 41.8723 42.2654 41.8499V35.2568H39.2889V41.8499C39.2889 41.8723 39.2889 41.8948 39.2777 41.906H42.2766ZM39.0194 41.906C39.0081 41.8948 38.9969 41.8723 38.9969 41.8499V35.2568H36.0317V41.8499C36.0317 41.8723 36.0317 41.8948 36.0205 41.906H39.0194ZM35.7621 41.906C35.7509 41.8948 35.7397 41.8723 35.7397 41.8499V35.2568H32.7744V41.8499C32.7744 41.8723 32.7632 41.8948 32.7632 41.906H35.7621ZM32.5049 41.906C32.4936 41.8948 32.4824 41.8723 32.4824 41.8499V35.2568H29.5172V41.8499C29.5172 41.8723 29.506 41.8948 29.4947 41.906H32.5049ZM29.2364 41.906C29.2252 41.8948 29.2252 41.8723 29.2252 41.8499V35.2568H26.2599V41.8499C26.2599 41.8723 26.2487 41.8948 26.2375 41.906H29.2364ZM25.9791 41.906C25.9679 41.8948 25.9679 41.8723 25.9679 41.8499V35.2568H22.9915V41.8499C22.9915 41.8723 22.9915 41.8948 22.9802 41.906H25.9791ZM22.7219 41.906C22.7107 41.8948 22.7107 41.8723 22.7107 41.8499V35.2568H19.7342V41.8499C19.7342 41.8723 19.7342 41.8948 19.723 41.906H22.7219ZM19.4647 41.906C19.4534 41.8948 19.4422 41.8723 19.4422 41.8499V35.2568H16.477V41.8499C16.477 41.8723 16.477 41.8948 16.4657 41.906H19.4647ZM16.2074 41.906C16.1962 41.8948 16.1849 41.8723 16.1849 41.8499V35.2568H13.1636V39.5473C13.1636 40.3223 13.5567 40.9176 14.0509 41.3108C14.5451 41.7151 15.1404 41.906 15.5223 41.906H16.2074ZM46.4773 42.58H15.5223C15.0168 42.58 14.2531 42.3329 13.6353 41.8274C12.9951 41.322 12.4897 40.5694 12.4897 39.5473V22.4524C12.4897 21.8684 12.8154 20.9586 13.4668 20.2959L13.4893 20.2734C13.9835 19.7792 14.6686 19.4198 15.5223 19.4198H46.4773C47.0614 19.4198 47.9824 19.7455 48.6451 20.4194C49.1393 20.9136 49.5099 21.5876 49.5099 22.4524V39.5473C49.5099 40.0528 49.2628 40.8165 48.7574 41.4455C48.252 42.0745 47.4882 42.58 46.4773 42.58ZM13.1074 44.8937H48.8922C49.757 44.8937 50.4422 44.5343 50.9364 44.0289C51.6328 43.3437 51.981 42.4002 51.981 41.8162V20.1836C51.981 19.3187 51.6103 18.6448 51.1161 18.1394C50.4197 17.4542 49.4875 17.106 48.8922 17.106H13.1074C12.2426 17.106 11.5574 17.4655 11.0632 17.9709C10.3668 18.656 10.0186 19.5995 10.0186 20.1836V41.8162C10.0186 42.681 10.3893 43.355 10.8835 43.8604C11.5799 44.5455 12.5121 44.8937 13.1074 44.8937ZM48.8922 45.5676H13.1074C12.3773 45.5676 11.2317 45.1521 10.4118 44.3321C9.80523 43.7144 9.35596 42.8832 9.35596 41.8162V20.1836C9.35596 19.4535 9.76031 18.3191 10.5915 17.4879C11.198 16.8814 12.0404 16.4321 13.1074 16.4321H48.8922C49.6223 16.4321 50.7567 16.8477 51.5878 17.6676C52.1944 18.2854 52.6436 19.1165 52.6436 20.1836V41.8162C52.6436 42.5463 52.2393 43.6807 51.4081 44.5118C50.8016 45.1184 49.9592 45.5676 48.8922 45.5676ZM45.5226 26.2151H42.5574V34.9647H45.5226V26.2151ZM42.2654 26.2151H39.2889V34.9647H42.2654V26.2151ZM38.9969 26.2151H36.0317V34.9647H38.9969V26.2151ZM35.7397 26.2151H32.7744V34.9647H35.7397V26.2151ZM32.4824 26.2151H29.5172V34.9647H32.4824V26.2151ZM29.2252 26.2151H26.2599V34.9647H29.2252V26.2151ZM25.9679 26.2151H22.9915V34.9647H25.9679V26.2151ZM22.7107 26.2151H19.7342V34.9647H22.7107V26.2151ZM19.4422 26.2151H16.477V34.9647H19.4422V26.2151Z"
            fill="#02161D"
            stroke="black"
            strokeWidth="1.01087"
            strokeMiterlimit="2.61313"
          />
        </g>
        <defs>
          <clipPath id="clip0_217_17">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 140,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر اتاق",
    pieceNameEN: "filter-room",
    className: "moveItem4",
    desc: "فیلتر اتاق قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
  {
    id: 13,
    src: "../assets/images/pieces/img_piece_filter_petrol.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.6381 28.6009L30.9087 20.3325C31.2299 20.0254 31.6232 19.9475 31.9747 19.9864C32.3251 20.0254 32.6453 20.189 32.8101 20.3538L33.5424 21.0871C33.8193 21.3649 33.9212 21.697 33.9212 22.0128C33.9212 22.4282 33.7321 22.8249 33.5438 23.0132L25.2967 31.2601C24.9714 31.5853 24.5678 31.6674 24.2068 31.6279C23.8572 31.5891 23.5376 31.4243 23.3726 31.2601L22.6381 30.527C22.3618 30.2508 22.2607 29.9176 22.2607 29.6015C22.2607 29.1861 22.4498 28.7892 22.6381 28.6009ZM44.8886 30.8807L29.3373 46.4309C28.5879 47.1685 27.686 47.4402 26.8274 47.4402C25.66 47.4402 24.561 46.9251 24.0471 46.4112L21.2641 43.6284L16.7574 48.1355C16.6306 48.2621 16.48 48.3616 16.3157 48.4299L16.2944 48.438C16.1358 48.5007 15.9658 48.5342 15.7945 48.5342C15.6161 48.5342 15.4388 48.4977 15.2745 48.4299C15.1087 48.3616 14.958 48.2621 14.8313 48.1355L13.843 47.1453C13.592 46.8825 13.4653 46.5432 13.4653 46.205C13.4653 45.8565 13.5988 45.5073 13.864 45.2422L18.371 40.7351L15.5777 37.9414C14.6971 37.0536 14.476 35.9496 14.586 34.9579C14.6951 33.9738 15.1422 33.0897 15.5884 32.6428L31.1183 17.1108C31.2493 16.98 31.4623 16.98 31.5932 17.1108L44.8886 30.406C45.0196 30.5368 45.0196 30.7498 44.8886 30.8807ZM28.8839 45.9364L44.1766 30.6433L31.3558 17.823L16.0635 33.1156C15.7043 33.4743 15.3438 34.2036 15.2517 35.031C15.1611 35.8481 15.3414 36.7557 16.0631 37.4774L19.0832 40.4977C19.214 40.6286 19.214 40.8416 19.0832 40.9725L14.3387 45.7169C14.2045 45.8511 14.1364 46.0288 14.1364 46.205C14.1364 46.3754 14.1991 46.5466 14.3235 46.6789L15.306 47.6608C15.3719 47.7266 15.4483 47.7776 15.5301 47.8114C15.6112 47.8453 15.7013 47.8632 15.7945 47.8632C15.8824 47.8632 15.9676 47.8471 16.0452 47.8176L16.0586 47.8114C16.14 47.7776 16.2168 47.7266 16.2825 47.6608L21.0266 42.9164C21.1575 42.7855 21.3706 42.7855 21.5014 42.9164L24.5218 45.9364C24.9376 46.3521 25.8456 46.7691 26.8274 46.7691C27.5274 46.7691 28.2612 46.5497 28.8671 45.9542L28.8839 45.9364ZM41.944 21.9995L47.6603 16.283C47.795 16.1484 47.8627 15.9711 47.8627 15.7946C47.8627 15.6174 47.7954 15.4401 47.6618 15.3065L46.6929 14.3392C46.6272 14.2733 46.5506 14.2225 46.4688 14.1885L46.4555 14.1825C46.378 14.1528 46.2928 14.1369 46.2049 14.1369C46.1117 14.1369 46.0215 14.1547 45.9401 14.1881C45.8587 14.2225 45.7819 14.2737 45.7164 14.3392L40.0001 20.0556C39.8692 20.1864 39.6562 20.1864 39.5254 20.0556L34.0764 14.6067C34.011 14.5412 33.9341 14.4898 33.852 14.456L33.8386 14.4499C33.761 14.4202 33.6758 14.4043 33.5884 14.4043C33.4952 14.4043 33.4057 14.4222 33.3243 14.4556C33.2414 14.4906 33.1638 14.5416 33.0992 14.6059L32.683 15.0224C32.6256 15.084 32.5799 15.156 32.548 15.2328L32.5418 15.2464C32.5122 15.3237 32.4962 15.4086 32.4962 15.4964C32.4962 15.5892 32.5144 15.6791 32.5476 15.7605C32.5818 15.8422 32.6332 15.919 32.6985 15.9845L46.0303 29.3169C46.0908 29.374 46.1619 29.4196 46.2387 29.4516L46.252 29.4576C46.3297 29.4873 46.4149 29.5033 46.5031 29.5033C46.5962 29.5033 46.6865 29.485 46.7678 29.452C46.8504 29.417 46.9276 29.366 46.9911 29.3025L47.3936 28.9003C47.5275 28.7649 47.5952 28.5876 47.5952 28.4112C47.5952 28.2339 47.5279 28.0566 47.3944 27.923L41.944 22.4742C41.8132 22.3433 41.8132 22.1303 41.944 21.9995ZM48.135 16.7579L42.6561 22.2368L47.8676 27.4483C48.1332 27.7154 48.2663 28.0643 48.2663 28.4112C48.2663 28.7588 48.1332 29.1088 47.8676 29.3744L47.4644 29.7757C47.3374 29.9027 47.1867 30.0028 47.0247 30.0701C46.8585 30.1379 46.6815 30.1743 46.5031 30.1743C46.3319 30.1743 46.1623 30.1409 46.0033 30.078L45.9816 30.0701C45.8283 30.0062 45.6852 29.9138 45.5628 29.7962L32.2238 16.4592C32.0972 16.3326 31.9975 16.1819 31.9294 16.0171C31.8617 15.8513 31.8251 15.6745 31.8251 15.4964C31.8251 15.3252 31.8587 15.1556 31.9214 14.997L31.9294 14.9757C31.9929 14.822 32.0858 14.6789 32.2029 14.5565L32.6252 14.1319C32.7542 14.0048 32.9047 13.9048 33.0675 13.8374C33.2335 13.7697 33.4099 13.7333 33.5884 13.7333C33.7592 13.7333 33.9288 13.7667 34.0878 13.8294L34.1091 13.8374C34.2739 13.9055 34.4244 14.0052 34.5512 14.1319L39.7627 19.3435L45.2417 13.8645C45.3683 13.7378 45.5194 13.6381 45.6834 13.57C45.8492 13.5024 46.0265 13.4658 46.2049 13.4658C46.3761 13.4658 46.5458 13.4992 46.7047 13.5621L46.726 13.57C46.8904 13.6385 47.041 13.7378 47.1677 13.8645L48.135 14.8318C48.4005 15.0989 48.5337 15.4477 48.5337 15.7946C48.5337 16.1423 48.4005 16.4924 48.135 16.7579ZM16.962 35.0561C16.962 34.5372 17.1728 34.0662 17.5124 33.7266C17.8521 33.3869 18.3231 33.1761 18.842 33.1761C19.3609 33.1761 19.8318 33.3869 20.1714 33.7266C20.5112 34.0662 20.7219 34.5372 20.7219 35.0561C20.7219 35.5749 20.5112 36.0459 20.1714 36.3856L20.1493 36.4057C19.8117 36.7332 19.3498 36.936 18.842 36.936C18.3231 36.936 17.8521 36.7254 17.5124 36.3856C17.1728 36.0459 16.962 35.5749 16.962 35.0561ZM17.9871 34.2013C17.7688 34.4197 17.633 34.7225 17.633 35.0561C17.633 35.3897 17.7688 35.6924 17.9871 35.9109C18.2056 36.1291 18.5084 36.265 18.842 36.265C19.1676 36.265 19.464 36.136 19.6811 35.9276L19.6967 35.9109C19.915 35.6924 20.0509 35.3897 20.0509 35.0561C20.0509 34.7225 19.915 34.4197 19.6967 34.2013C19.4783 33.983 19.1756 33.8471 18.842 33.8471C18.5084 33.8471 18.2056 33.983 17.9871 34.2013ZM31.3599 20.8285L23.1128 29.0758C23.0226 29.1658 22.9317 29.3716 22.9317 29.6015C22.9317 29.7566 22.9804 29.9198 23.1128 30.0523L23.8457 30.7852C23.9223 30.8621 24.087 30.9405 24.2798 30.9622C24.4625 30.9823 24.6641 30.9431 24.8216 30.7856L33.0691 22.5385C33.1593 22.4483 33.2502 22.2425 33.2502 22.0128C33.2502 21.8564 33.2011 21.6928 33.0691 21.5604L32.3357 20.8289C32.2584 20.7517 32.0942 20.6733 31.9017 20.652C31.7248 20.6327 31.5297 20.6683 31.3748 20.813L31.3599 20.8285Z"
          fill="#02161D"
          stroke="black"
          strokeWidth="1.00661"
          strokeMiterlimit="2.61313"
        />
      </svg>
    ),
    top: 190,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "فیلتر بنزین",
    pieceNameEN: "filter-petrol",
    className: "moveItem5",
    desc: "فیلتر بنزین قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
  {
    id: 14,
    src: "../assets/images/pieces/img_piece_glass_cleaner.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M42.0908 21.4263C41.9129 21.3806 41.8023 21.2003 41.8479 21.02C41.8936 20.8397 42.0763 20.7315 42.2543 20.7772C43.6487 21.1282 45.0263 21.5465 46.3799 22.0274C47.7335 22.5082 49.0654 23.0516 50.3685 23.6574C50.871 23.8906 51.3134 24.2248 51.6692 24.6311L51.6836 24.648C52.0346 25.0519 52.3015 25.5255 52.465 26.0448C52.6309 26.5689 52.6838 27.1195 52.6237 27.6581C52.566 28.1942 52.3953 28.7207 52.1212 29.1992L47.142 37.8231C46.6396 38.679 45.8606 39.2825 44.9782 39.5758C44.0887 39.8691 43.0957 39.8474 42.1797 39.4508L42.1509 39.4363C41.6219 39.2079 41.081 38.9964 40.5352 38.7992C40.0568 38.6285 39.5736 38.4698 39.0855 38.3232L34.6762 44.8651C34.7603 45.1704 34.8036 45.4926 34.8036 45.8219C34.8036 46.8293 34.3949 47.7405 33.7361 48.3993C33.0774 49.0604 32.1662 49.4667 31.1588 49.4667C30.1514 49.4667 29.2402 49.0604 28.5815 48.3993C27.9227 47.7405 27.514 46.8293 27.514 45.8219C27.514 44.817 27.9227 43.9058 28.5815 43.2446C29.2018 42.6267 30.0432 42.2276 30.9785 42.1819L34.7194 37.3903C32.284 37.0682 29.8293 37.0682 27.4178 37.3807C24.8141 37.7197 22.2608 38.4242 19.8301 39.4844C18.9117 39.8835 17.9163 39.9076 17.0244 39.6142C16.1348 39.3209 15.3486 38.7103 14.8462 37.8423L9.88145 29.24C9.60496 28.7616 9.43426 28.2351 9.37656 27.6989C9.31646 27.1628 9.36935 26.6146 9.53284 26.0905C9.69873 25.564 9.9704 25.0831 10.3262 24.6768C10.6821 24.2705 11.122 23.9363 11.6221 23.7031C12.6271 23.2343 13.6441 22.8015 14.6658 22.4097C15.654 22.0322 16.6565 21.6884 17.6663 21.3806L22.4699 12.7038C22.5589 12.5427 22.7633 12.485 22.9243 12.574C22.982 12.6052 23.0253 12.6509 23.0542 12.7038L26.8504 19.5607L28.9998 15.6802C29.0888 15.5192 29.2931 15.4615 29.4542 15.5528C29.5119 15.5841 29.5552 15.6298 29.584 15.6802L31.6372 19.3875C32.647 19.402 33.6472 19.4477 34.6353 19.5246H34.6425C35.7004 19.6087 36.7558 19.7289 37.8065 19.8852C37.9892 19.9117 38.1166 20.0824 38.0901 20.2651C38.0637 20.4478 37.893 20.5752 37.7103 20.5488C36.6741 20.3949 35.633 20.2747 34.5896 20.1954L34.5824 20.193C33.7193 20.1256 32.8634 20.0824 32.0099 20.0631L33.2697 22.3375C33.3899 22.5539 33.4716 22.7919 33.5101 23.0323C33.5486 23.2752 33.5462 23.5252 33.5005 23.768C33.3082 24.7802 32.772 25.6529 32.0243 26.2708C31.279 26.8911 30.3197 27.2566 29.2907 27.2566C28.6632 27.2566 28.0622 27.1195 27.5212 26.8743C27.3 27.1556 27.0548 27.4176 26.7903 27.6533C25.718 28.6173 24.2995 29.1968 22.7633 29.1968C21.2246 29.1968 19.8061 28.6173 18.7338 27.6533C17.6615 26.6916 16.9306 25.3476 16.7623 23.8161C16.7383 23.5973 16.7479 23.3761 16.7912 23.1646C16.8345 22.9506 16.909 22.7438 17.0172 22.5491L17.0292 22.5299L17.1951 22.2293C16.4233 22.4794 15.6588 22.7486 14.9039 23.0372C13.8821 23.4266 12.8819 23.8522 11.9058 24.309C11.4923 24.5037 11.1268 24.7802 10.8311 25.1168C10.5378 25.4534 10.3094 25.8525 10.1724 26.2901C10.0353 26.7276 9.99204 27.1844 10.0401 27.6292C10.0906 28.074 10.2301 28.5092 10.4585 28.9058L15.4256 37.5081C15.8415 38.227 16.4955 38.7343 17.236 38.9771C17.9765 39.2224 18.8035 39.2031 19.5632 38.8713C22.0516 37.787 24.6674 37.0658 27.3313 36.7172C29.9326 36.3782 32.5821 36.395 35.1979 36.7773L42.8313 26.9969C43.0933 26.6387 43.478 26.4175 43.8843 26.3526C44.293 26.2877 44.7234 26.379 45.084 26.6387C45.4447 26.9007 45.6634 27.2854 45.7284 27.6917C45.7933 28.0956 45.7043 28.526 45.4471 28.8842L39.4774 37.7438C39.9077 37.876 40.3357 38.0178 40.7588 38.1693C41.3166 38.3713 41.8696 38.5876 42.4153 38.8233L42.4442 38.8353C43.2063 39.1647 44.031 39.1815 44.7691 38.9387C45.5024 38.6958 46.1491 38.1933 46.565 37.4841L51.5418 28.865C51.7702 28.4683 51.9096 28.0331 51.9601 27.5859C52.0082 27.1412 51.9649 26.6844 51.8255 26.2468C51.6908 25.814 51.4672 25.4221 51.1787 25.088L51.1643 25.0735C50.8686 24.7369 50.5031 24.458 50.0896 24.2657C48.8033 23.6695 47.4906 23.1309 46.1563 22.6573C44.8244 22.1837 43.466 21.7725 42.0908 21.4263ZM33.9958 44.93L33.9934 44.9228L33.991 44.9131L33.9886 44.9035L33.9861 44.8987C33.8395 44.4491 33.587 44.0476 33.2625 43.7206C32.7239 43.1821 31.9786 42.8503 31.1588 42.8503C30.3389 42.8503 29.5936 43.1821 29.0575 43.7206C28.519 44.2592 28.1848 45.0021 28.1848 45.8219C28.1848 46.6442 28.519 47.3871 29.0575 47.9256C29.5936 48.4642 30.3389 48.796 31.1588 48.796C31.9786 48.796 32.7239 48.4642 33.2625 47.9256C33.7986 47.3871 34.1328 46.6442 34.1328 45.8219C34.1328 45.5118 34.0847 45.2113 33.9958 44.93ZM34.378 44.1101L44.9013 28.4947C45.0528 28.2856 45.1057 28.0331 45.0696 27.7975C45.0311 27.5595 44.9013 27.3359 44.6921 27.182C44.4806 27.0282 44.2281 26.9753 43.9901 27.0137C43.7521 27.0522 43.5285 27.1796 43.3746 27.3912L35.6138 37.3326L35.5946 37.3567L31.7887 42.2324C32.5412 42.3647 33.2168 42.7277 33.7361 43.2446C33.991 43.4995 34.2073 43.7904 34.378 44.1101ZM27.2327 20.2507L28.5069 22.5491C28.6127 22.7414 28.6897 22.9482 28.7329 23.1646C28.7762 23.3761 28.7858 23.5973 28.7618 23.8161C28.6632 24.7273 28.3627 25.5736 27.9107 26.3117C28.3386 26.4896 28.8051 26.5858 29.2907 26.5858C30.161 26.5858 30.9664 26.278 31.5964 25.7539C32.2263 25.2322 32.6807 24.4965 32.8417 23.6454C32.873 23.4771 32.8754 23.304 32.849 23.1381C32.8225 22.9722 32.7672 22.8112 32.6855 22.6621L31.1564 19.8996L31.1516 19.8924L31.1468 19.8852L31.1444 19.878L31.1396 19.8708L29.2907 16.5337L27.2327 20.2507ZM22.7633 13.5573L18.1952 21.8062L18.1736 21.8423L17.6038 22.8737C17.5317 23.0059 17.4788 23.1477 17.4499 23.2944C17.4187 23.4435 17.4115 23.5973 17.4283 23.7464C17.5774 25.1048 18.2265 26.3021 19.181 27.1556C20.133 28.0115 21.3928 28.526 22.7633 28.526C24.1313 28.526 25.3911 28.0115 26.3455 27.1556C26.5547 26.968 26.7494 26.7637 26.9274 26.5449C26.7999 26.4608 26.6773 26.3694 26.5595 26.2708C25.8118 25.6529 25.2733 24.7802 25.0833 23.768C25.0376 23.5252 25.0352 23.2752 25.0737 23.0323C25.1122 22.7895 25.1939 22.5539 25.3117 22.3375L25.3237 22.3183L26.4682 20.2507L22.7633 13.5573ZM27.3168 25.9991C27.7328 25.3332 28.0069 24.571 28.0958 23.7464C28.1126 23.5973 28.1054 23.4435 28.0766 23.2944C28.0477 23.1501 27.9948 23.0083 27.9203 22.8737L26.8504 20.9431L25.9008 22.6597C25.8166 22.8112 25.7613 22.9746 25.7349 23.1381C25.7084 23.304 25.7084 23.4771 25.7421 23.6454C25.9032 24.4965 26.3552 25.2322 26.9851 25.7539C27.0908 25.8429 27.2014 25.9246 27.3168 25.9991Z"
          fill="#02161D"
          stroke="#02161D"
          strokeWidth="1.00737"
          strokeMiterlimit="2.61313"
        />
      </svg>
    ),
    top: 240,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "شیشه شور",
    pieceNameEN: "glassCleaner",
    className: "moveItem6",
    desc: " شیشه شور قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
  {
    id: 15,
    src: "../assets/images/pieces/img_piece_radiator.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M51.4808 45.2299C51.3845 45.2437 51.4533 45.9184 51.4533 46.0423C51.4533 46.5655 51.3431 47.0749 51.1504 47.5568C50.9439 48.0387 50.6547 48.4793 50.283 48.8511L50.2554 48.8786C49.8974 49.2366 49.4568 49.5257 48.9887 49.7185C48.5068 49.9113 47.9836 50.0214 47.4604 50.0214H14.5397C13.4382 50.0214 12.4469 49.5808 11.7171 48.8511C11.0011 48.1351 10.5606 47.13 10.5606 46.0423V28.7764L10.5468 28.7489C10.533 28.7351 10.533 28.7351 10.5192 28.7351H7.73799C7.35247 28.7351 6.99449 28.5699 6.73288 28.3221C6.47128 28.0605 6.31982 27.7025 6.31982 27.3032V26.1053C6.31982 25.7061 6.47128 25.3481 6.73288 25.1002L6.76042 25.0727C7.00825 24.8249 7.36624 24.6734 7.73799 24.6734H10.5192H10.5468C10.5468 24.6596 10.5606 24.6459 10.5606 24.6459V23.9437C10.5606 22.8422 11.0011 21.8508 11.7171 21.1349C12.4055 20.4464 13.328 20.0059 14.3607 19.9645V18.6703C14.3607 18.3812 14.4158 18.1058 14.5259 17.8442C14.6361 17.5826 14.7875 17.3485 14.994 17.142L15.0216 17.1282C15.2143 16.9355 15.4484 16.784 15.6962 16.6739C15.9578 16.5637 16.2332 16.5086 16.5224 16.5086H19.7855V12.6397H18.3811C18.2021 12.6397 18.0507 12.4882 18.0507 12.3092C18.0507 12.1302 18.2021 11.9788 18.3811 11.9788H20.1022H24.7697H26.3807C26.5597 11.9788 26.7111 12.1302 26.7111 12.3092C26.7111 12.4882 26.5597 12.6397 26.3807 12.6397H25.1002V16.5086H38.6623C38.9101 16.5086 39.1442 16.5499 39.3782 16.6325C39.6123 16.7152 39.8188 16.8391 40.0116 16.9905L43.6878 19.9645H47.4604C47.9836 19.9645 48.5068 20.0609 48.9887 20.2675C49.4706 20.4602 49.9112 20.7631 50.283 21.1349C50.6547 21.5066 50.9439 21.9472 51.1504 22.4291C51.3431 22.8973 51.4533 23.4205 51.4533 23.9437C51.4533 25.4444 51.412 41.1269 51.4671 41.1682H54.2621C54.4411 41.1682 54.6338 41.2095 54.7991 41.2783C54.9781 41.3609 55.1295 41.4573 55.2672 41.595C55.4049 41.7189 55.5013 41.8842 55.5701 42.0494C55.6527 42.2284 55.6803 42.4074 55.6803 42.6001V43.798C55.6803 43.9907 55.6527 44.1697 55.5701 44.3487C55.5013 44.5277 55.4049 44.6792 55.2672 44.8169C55.1295 44.9408 54.9781 45.0509 54.7991 45.1198L54.7853 45.1335C54.6201 45.1886 54.4411 45.2299 54.2621 45.2299H51.4808ZM47.2814 23.1589C47.2814 23.0763 47.3502 23.0212 47.4329 23.0212C47.5155 23.0212 47.5705 23.0763 47.5705 23.1589V46.7858C47.5705 46.8684 47.5155 46.9372 47.4329 46.9372C47.3502 46.9372 47.2814 46.8684 47.2814 46.7858V23.1589ZM43.6465 23.1589C43.6465 23.0763 43.7153 23.0212 43.798 23.0212C43.8668 23.0212 43.9356 23.0763 43.9356 23.1589V46.7995C43.9356 46.8684 43.8668 46.9372 43.798 46.9372C43.7153 46.9372 43.6465 46.8684 43.6465 46.7995V23.1589ZM40.0116 23.1589C40.0116 23.09 40.0804 23.0212 40.1493 23.0212C40.2319 23.0212 40.3007 23.09 40.3007 23.1589V46.7995C40.3007 46.8822 40.2319 46.951 40.1493 46.951C40.0804 46.951 40.0116 46.8822 40.0116 46.7995V23.1589ZM36.3767 23.1726C36.3767 23.09 36.4455 23.0212 36.5144 23.0212C36.597 23.0212 36.6658 23.09 36.6658 23.1726V46.8133C36.6658 46.8959 36.597 46.951 36.5144 46.951C36.4455 46.951 36.3767 46.8959 36.3767 46.8133V23.1726ZM32.7418 23.1726C32.7418 23.09 32.7968 23.0349 32.8795 23.0349C32.9621 23.0349 33.0171 23.09 33.0171 23.1726V46.8133C33.0171 46.8959 32.9621 46.9648 32.8795 46.9648C32.7968 46.9648 32.7418 46.8959 32.7418 46.8133V23.1726ZM29.1069 23.1726C29.1069 23.09 29.1619 23.0349 29.2445 23.0349C29.3272 23.0349 29.3822 23.09 29.3822 23.1726V46.8271C29.3822 46.9097 29.3272 46.9648 29.2445 46.9648C29.1619 46.9648 29.1069 46.9097 29.1069 46.8271V23.1726ZM25.4582 23.1726C25.4582 23.1038 25.527 23.0349 25.6096 23.0349C25.6785 23.0349 25.7473 23.1038 25.7473 23.1726V46.8409C25.7473 46.9097 25.6785 46.9785 25.6096 46.9785C25.527 46.9785 25.4582 46.9097 25.4582 46.8409V23.1726ZM21.8233 23.1864C21.8233 23.1038 21.8921 23.0349 21.9747 23.0349C22.0436 23.0349 22.1124 23.1038 22.1124 23.1864V46.8409C22.1124 46.9235 22.0436 46.9785 21.9747 46.9785C21.8921 46.9785 21.8233 46.9235 21.8233 46.8409V23.1864ZM18.1884 23.1864C18.1884 23.1038 18.2572 23.0487 18.326 23.0487C18.4087 23.0487 18.4775 23.1038 18.4775 23.1864V46.8546C18.4775 46.9235 18.4087 46.9923 18.326 46.9923C18.2572 46.9923 18.1884 46.9235 18.1884 46.8546V23.1864ZM14.5534 23.1864C14.5534 23.1038 14.6085 23.0487 14.6911 23.0487C14.7737 23.0487 14.8288 23.1038 14.8288 23.1864V46.8546C14.8288 46.9372 14.7737 47.0061 14.6911 47.0061C14.6085 47.0061 14.5534 46.9372 14.5534 46.8546V23.1864ZM20.4464 16.5086H24.4531V12.6397H20.4464V16.5086ZM15.0216 19.9645H42.6414L39.5985 17.5C39.4746 17.3898 39.3232 17.3072 39.1579 17.2521C39.0065 17.1971 38.8275 17.1695 38.6623 17.1695H24.7835H20.116H16.5224C16.3158 17.1695 16.1231 17.2108 15.9441 17.2797C15.7789 17.3485 15.6136 17.4587 15.4759 17.5963L15.4622 17.6101C15.3245 17.7478 15.2143 17.913 15.1317 18.092C15.0629 18.271 15.0216 18.4638 15.0216 18.6703V19.9645ZM51.2192 44.6241C51.3018 44.5828 51.3982 44.569 51.4808 44.569H54.2621C54.3585 44.569 54.4548 44.5553 54.5375 44.514C54.6338 44.4727 54.7302 44.4176 54.7991 44.3487C54.8817 44.2661 54.9367 44.1835 54.9643 44.1009C55.0056 44.0045 55.0331 43.9081 55.0331 43.798V42.6001C55.0331 42.49 55.0056 42.3936 54.9643 42.311C54.9367 42.2146 54.8817 42.132 54.7991 42.0631C54.7302 41.9805 54.6476 41.9255 54.5512 41.8842C54.4686 41.8566 54.3585 41.8291 54.2621 41.8291H51.4808C51.3982 41.8291 51.3156 41.8153 51.2468 41.7878L51.2192 41.774C51.1366 41.7465 51.054 41.6914 50.9989 41.6226C50.9301 41.5675 50.875 41.4849 50.8475 41.4023C50.8062 41.3196 50.7924 41.2233 50.7924 41.1407V23.9437C50.7924 23.5031 50.696 23.0762 50.5308 22.677C50.3656 22.2777 50.1315 21.9059 49.8148 21.5892C49.4981 21.2863 49.1402 21.0385 48.7409 20.8733C48.3416 20.7081 47.901 20.6254 47.4604 20.6254H14.7049H14.5397C13.6172 20.6254 12.7911 20.9972 12.1852 21.5892C11.5932 22.1951 11.2077 23.0349 11.2077 23.9437V24.6459C11.2077 24.8386 11.1388 25.0039 11.0149 25.1278C10.891 25.2655 10.712 25.3343 10.5192 25.3343H7.73799C7.54523 25.3343 7.35247 25.4169 7.21478 25.5408L7.20101 25.5684C7.06333 25.7061 6.98072 25.8988 6.98072 26.1053V27.3032C6.98072 27.5235 7.06333 27.7163 7.20101 27.854C7.3387 27.9916 7.53146 28.0743 7.73799 28.0743H10.5192C10.712 28.0743 10.891 28.1569 11.0149 28.2808C11.1388 28.4047 11.2077 28.5837 11.2077 28.7764V46.0423C11.2077 46.951 11.5932 47.7909 12.1852 48.3829C12.7911 48.9888 13.6172 49.3605 14.5397 49.3605H47.4604C47.901 49.3605 48.3416 49.2779 48.7409 49.1127C49.1264 48.9474 49.4844 48.7134 49.8011 48.4105L49.8148 48.3829C50.1315 48.08 50.3656 47.7083 50.5308 47.309C50.696 46.9097 50.7924 46.4829 50.7924 46.0423V45.2712C50.7924 45.1749 50.8062 45.0922 50.8337 45.0234L50.8475 44.9959C50.875 44.9132 50.9301 44.8444 50.9989 44.7756C51.054 44.7067 51.1366 44.6654 51.2192 44.6241Z"
          fill="#02161D"
          stroke="#02161D"
          strokeWidth="1.00511"
          strokeMiterlimit="2.61313"
        />
      </svg>
    ),
    top: 280,
    right: 100,
    opacity: 0,
    visibility: "hidden",
    isSelect: false,
    pieceName: "رادیاتور",
    pieceNameEN: "radiatorWater",
    className: "moveItem7",
    desc: "  رادیاتور قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
  {
    id: 16,
    src: "../assets/images/pieces/img_piece_battery.svg",
    svg: (
      <svg
        width="62"
        height="62"
        viewBox="0 0 62 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_216_2)">
          <path
            d="M46.2635 18.5117V15.8488C46.2635 15.4799 46.1191 15.1911 45.9105 14.9826C45.6058 14.6778 45.2047 14.5334 44.9481 14.5334H38.724C38.355 14.5334 38.0663 14.6778 37.8578 14.8863C37.553 15.1911 37.4086 15.5922 37.4086 15.8488V18.5117H46.2635ZM15.4158 34.7777C15.0469 34.7777 14.7582 34.4889 14.7582 34.136C14.7582 33.7831 15.0469 33.4944 15.4158 33.4944H25.0086C25.3615 33.4944 25.6503 33.7831 25.6503 34.136C25.6503 34.4889 25.3615 34.7777 25.0086 34.7777H15.4158ZM36.9915 34.7777C36.6386 34.7777 36.3499 34.4889 36.3499 34.136C36.3499 33.7831 36.6386 33.4944 36.9915 33.4944H41.1463V29.3396C41.1463 28.9707 41.435 28.698 41.7879 28.698C42.1408 28.698 42.4296 28.9707 42.4296 29.3396V33.4944H46.6003C46.9532 33.4944 47.242 33.7831 47.242 34.136C47.242 34.4889 46.9532 34.7777 46.6003 34.7777H42.4296V38.9324C42.4296 39.2853 42.1408 39.5741 41.7879 39.5741C41.435 39.5741 41.1463 39.2853 41.1463 38.9324V34.7777H36.9915ZM11.4697 47.4825H50.5465C51.525 47.4825 52.2629 46.9852 52.7442 46.3756C53.2415 45.75 53.4981 45.0121 53.4981 44.5148V23.7572C53.4981 22.7627 53.0008 22.0248 52.3913 21.5435C51.7657 21.0462 51.0278 20.7896 50.5465 20.7896H11.4697C10.4751 20.7896 9.7372 21.2869 9.25595 21.8964C8.75867 22.522 8.50201 23.2599 8.50201 23.7572V44.5148C8.50201 45.4933 8.99929 46.2312 9.60886 46.7285C10.2345 47.2258 10.9724 47.4825 11.4697 47.4825ZM50.5465 48.1241H11.4697C10.8601 48.1241 9.96177 47.8193 9.20783 47.2258C8.45388 46.6323 7.86035 45.7179 7.86035 44.5148V23.7572C7.86035 23.1477 8.16514 22.2493 8.75867 21.4954C9.3522 20.7415 10.2505 20.1479 11.4697 20.1479H50.5465C51.14 20.1479 52.0544 20.4527 52.7923 21.0462C53.5462 21.6398 54.1398 22.5381 54.1398 23.7572V44.5148C54.1398 45.1244 53.851 46.0227 53.2575 46.7606C52.6479 47.5145 51.7496 48.1241 50.5465 48.1241ZM48.9263 44.8677H13.0738C12.5124 44.8677 12.0792 44.6271 11.7584 44.3063L11.7263 44.2902C11.3253 43.8731 11.1168 43.2796 11.1168 42.9107V25.3614C11.1168 24.7999 11.3413 24.3668 11.6622 24.046C12.0953 23.6129 12.6888 23.4043 13.0738 23.4043H48.9263C49.4878 23.4043 49.9209 23.6289 50.2417 23.9497C50.6748 24.3828 50.8834 24.9764 50.8834 25.3614V42.9107C50.8834 43.4721 50.6588 43.9052 50.338 44.2261L50.3219 44.2421C49.8888 44.6592 49.3113 44.8677 48.9263 44.8677ZM13.0738 44.2261H48.9263C49.1669 44.2261 49.568 44.0817 49.8567 43.7929L49.8728 43.7769C50.0973 43.5684 50.2417 43.2636 50.2417 42.9107V25.3614C50.2417 25.1047 50.0974 24.7037 49.7926 24.4149C49.584 24.1903 49.2953 24.046 48.9263 24.046H13.0738C12.8171 24.046 12.4321 24.1903 12.1274 24.4951C11.9028 24.7037 11.7584 24.9924 11.7584 25.3614V42.9107C11.7584 43.1513 11.9028 43.5363 12.1915 43.8411L12.2076 43.8571C12.4161 44.0656 12.7049 44.2261 13.0738 44.2261ZM15.095 18.8325V15.8488C15.095 15.2874 15.3196 14.8382 15.6404 14.5174C16.0735 14.1003 16.6671 13.8757 17.0521 13.8757H23.2761C23.8376 13.8757 24.2867 14.1164 24.6076 14.4372C25.0246 14.8703 25.2492 15.4638 25.2492 15.8488V18.8325C25.2492 19.009 25.1049 19.1534 24.9284 19.1534H15.4158C15.2394 19.1534 15.095 19.009 15.095 18.8325ZM15.7367 15.8488V18.5117H24.6076V15.8488C24.6076 15.5922 24.4472 15.1911 24.1424 14.8863C23.9338 14.6778 23.6451 14.5334 23.2761 14.5334H17.0521C16.7954 14.5334 16.3944 14.6778 16.1056 14.9826C15.881 15.1911 15.7367 15.4799 15.7367 15.8488ZM46.9212 15.8488V18.8325C46.9212 19.009 46.7768 19.1534 46.6003 19.1534H37.0878C36.8953 19.1534 36.7509 19.009 36.7509 18.8325V15.8488C36.7509 15.4638 36.9755 14.8703 37.3926 14.4372C37.7134 14.1164 38.1626 13.8757 38.724 13.8757H44.9481C45.3331 13.8757 45.9266 14.1003 46.3597 14.5174C46.6805 14.8382 46.9212 15.2874 46.9212 15.8488Z"
            fill="#02161D"
            stroke="#02161D"
            strokeWidth="1.01061"
            strokeMiterlimit="2.61313"
          />
        </g>
        <defs>
          <clipPath id="clip0_216_2">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    top: 240,
    right: 30,
    opacity: 1,
    visibility: "visible",
    isSelect: false,
    pieceName: "باطری",
    pieceNameEN: "battery",
    className: "moveItem8",
    desc: "  باطری قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد.",
  },
];

const PIECES_TERMS_MIN = [
  {
    id: 1,
    src: "../assets/images/pieces/img_short.svg",
    top: 8,
    right: 5,
    dir: "ltr",
    isSelect: true,
    termsName: "کوتاه مدت",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_mid.svg",
    top: 17,
    right: 6.5,
    dir: "ltr",
    isSelect: false,
    termsName: "میان مدت",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_long.svg",
    top: 24,
    right: 4,
    dir: "ltr",
    isSelect: false,
    termsName: "بلند مدت",
  },
];

const PIECES_SHORT2_MIN = [
  {
    id: 1,
    src: "../assets/images/pieces/img_piece_oil_motor.svg",
    top: 1.5,
    right: 1.5,
    isSelect: true,
    pieceName: "روغن موتور",
    pieceNameEN: "oil-motor",
    desc: "کار اصلی روغن در موتور خودرو، روان‌سازی و به حداقل رساندن اصطکاک بین اجزای موتور است. البته روغن موتورها وظایف بسیار مهم دیگری در موتور خودرو برعهده دارند. جلوگیری از زنگ‌زدگی و خوردگی موتور، پاک‌کنندگی موتور و معلق سازی مواد حاصل از سایش قطعات، آب بندی موتور، حفاظت از سطوح فلزی موتور، افزایش کارایی موتور و برخی از ویژگی‌های دیگر، همگی از وظایف روغن موتور است.",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_piece_oil_filter.svg",
    top: 4.5,
    right: 5.5,
    isSelect: false,
    pieceName: "فیلتر روغن",
    pieceNameEN: "oil-filter",
    desc: "فیلتر روغن قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_piece_filter_motor.svg",
    top: 6.2,
    right: 10,
    isSelect: false,
    pieceName: "فیلتر موتور",
    pieceNameEN: "filter-motor",
    desc: "فیلتر روغن وظیفه حذف ناخالصی و جذب ذرات مضر از درون روغن موتور را بر عهده دارد.",
  },
  {
    id: 4,
    src: "../assets/images/pieces/img_piece_filter_room.svg",
    top: 7,
    right: 15,
    isSelect: false,
    pieceName: "فیلتر اتاق",
    pieceNameEN: "filter-room",
    desc: "فیلتر اتاق قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
  {
    id: 5,
    src: "../assets/images/pieces/img_piece_filter_petrol.svg",
    top: 7,
    right: 21,
    isSelect: false,
    pieceName: "فیلتر بنزین",
    pieceNameEN: "filter-petrol",
    desc: "فیلتر بنزین قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
  {
    id: 6,
    src: "../assets/images/pieces/img_piece_glass_cleaner.svg",
    top: 6,
    right: 26,
    isSelect: false,
    pieceName: "شیشه شور",
    pieceNameEN: "glassCleaner",
    desc: "شیشه شور  قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
  {
    id: 7,
    src: "../assets/images/pieces/img_piece_radiator.svg",
    top: 3.9,
    right: 30.5,
    isSelect: false,
    pieceName: "رادیاتور",
    pieceNameEN: "radiatorWater",
    desc: " رادیاتور قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
  {
    id: 8,
    src: "../assets/images/pieces/img_piece_battery.svg",
    top: 1,
    right: 34,
    isSelect: false,
    pieceName: "باطری",
    pieceNameEN: "battery",
    desc: "باطری  قطعه‌ای است که وظیفه مهم تصفیه روغن را در موتورهای احتراق داخلی برعهده دارد. برای درک بهتر اهمیت این قطعه، باید به اهمیت روغن در سیستم موتور اشاره کرد.روغن از سه جهت در موتورهای احتراق داخلی اهمیت دارد که عبارتند از: ",
  },
];
const PIECES_TERMS2_MIN = [
  {
    id: 1,
    src: "../assets/images/pieces/img_short.svg",
    top: 3,
    right: 3,
    dir: "ltr",
    isSelect: true,
    termsName: "کوتاه مدت",
  },
  {
    id: 2,
    src: "../assets/images/pieces/img_mid.svg",
    top: 5,
    right: 12.5,
    dir: "ltr",
    isSelect: false,
    termsName: "میان مدت",
  },
  {
    id: 3,
    src: "../assets/images/pieces/img_long.svg",
    top: 3.5,
    right: 22,
    dir: "ltr",
    isSelect: false,
    termsName: "بلند مدت",
  },
];

export {
  PIECES_TERMS,
  PIECES_SHORT,
  PIECES_MID,
  PIECES_LONG,
  PIECES_SHORT2,
  PIECES_LONG2,
  PIECES_MID2,
  PIECES_TERMS2,
  PIECES_SHORT_MIN,
  PIECES_TERMS_MIN,
  PIECES_SHORT2_MIN,
  PIECES_TERMS2_MIN,
};
